(() => {
    "use strict";
    var e = {
            d: (t, s) => {
                for (var i in s) e.o(s, i) && !e.o(t, i) && Object.defineProperty(t, i, { enumerable: !0, get: s[i] });
            },
            o: (e, t) => Object.prototype.hasOwnProperty.call(e, t),
            r: (e) => {
                "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
            },
        },
        t = {};
    function s(e) {
        const t = document.createElement("template");
        return (t.innerHTML = e), t.content;
    }
    e.r(t),
        e.d(t, {
            AtatchKlavioToForms: () => ce,
            GlobalAppToggle: () => GlobalAppToggle,
            GlobalCartUpsells: () => GlobalCartUpsells,
            CartRecommendations: () => CartRecommendations,
            GlobalFeaturedPostSlider: () => le,
            GlobalGloblisationForm: () => GlobalGloblisationForm,
            GlobalGloblisationToggle: () => GlobalGloblisationToggle,
            GlobalInstagramSlider: () => oe,
            GlobalOptionSelector: () => GlobalOptionSelector,
            GlobalProductThumbnail: () => GlobalProductThumbnail,
            GlobalSearchForm: () => GlobalSearchForm,
            GlobalSidebar: () => GlobalSidebar,
            GlobalSidebarCart: () => GlobalSidebarCart,
            GlobliazationHelper: () => GlobliazationHelper,
            ModalBox: () => ModalBox,
            Navigation: () => ie,
            Pagination: () => ae,
            ProductOptionSelector: () => ProductOptionSelector,
            Scrollbar: () => ne,
            ShopifyUtils: () => ShopifyUtils,
            parseHTML: () => s,
        });
    class ObserverLite {
        constructor(e) {
            if (((e = e || {}), (this.id = Math.floor(999999999999 * Math.random())), (this.settings = e), e.key)) {
                if (((window.GlobalObersverLiteInstances = window.GlobalObersverLiteInstances || {}), window.GlobalObersverLiteInstances[e.key])) return window.GlobalObersverLiteInstances[e.key];
                window.GlobalObersverLiteInstances[e.key] = this;
            }
        }
        once() {
            return new Promise((e, t) => {
                this.onceDone && e(this.onceDone);
                const s = this.subscribe((t) => {
                    (t = t || !0), (this.onceDone = t), e(t), this.unsubscribe(s);
                });
            });
        }
        setOnce(e) {
            (e = e || !0), (this.onceDone = e);
        }
        next(...e) {
            this.onceDone || this.setOnce(...e),
                this.subject &&
                    this.subject.length &&
                    this.subject.forEach(({ callback: t }) => {
                        t(...e);
                    });
        }
        subscribe(e) {
            return (this.subject = this.subject || []), (e = { callback: e, id: Math.floor(1e14 + 9e14 * Math.random()) }), this.subject.push(e), e;
        }
        unsubscribe(e) {
            this.subject = this.subject.filter(({ id: t }) => t !== e.id);
        }
        unsubscribeAll(e) {
            this.subject?.forEach((e) => this.unsubscribe(e)), e && (this.onceDone = !1);
        }
    }
    class ModalBox {
        constructor({ content: e, settings: t }) {
            window.ModalBoxInstance?.active && window.ModalBoxInstance.close(), (window.ModalBoxInstance = this), (this.content = e), (this.settings = t || { containerCloseButton: !0 }), (this.ObserverLite = new ObserverLite());
        }
        subscribe(e) {
            return this.ObserverLite.subscribe(e);
        }
        next(e) {
            this.ObserverLite.next(e);
        }
        toggle() {
            this.active ? this.close() : this.open();
        }
        open() {
            return (
                (this.active = !0),
                this.next({ type: "open" }),
                new Promise((e, t) => {
                    if (!this.wrapper) {
                        let e = `<div class="modal-wrapper ${this.settings.wrapperClass ? this.settings.wrapperClass : ""}"\n                            style="${
                            this.settings.wrapperStyles ? this.settings.wrapperStyles : ""
                        }">\n                         <div class="modal-mask modal-close"></div>\n                         <div class="modal-flex">\n                           <div class="modal-content  \n                                       ${
                            this.settings.contentClass ? `${this.settings.contentClass}` : ""
                        }\n                                       ${this.settings.overlayClose ? "modal-close" : ""}">\n                              ${
                            this.settings.containerCloseButton ? '<button aria-label="close" class="modal-close modal-close-btn btn-reset"></button>' : ""
                        }\n                           </div>\n                         </div>\n                       </div>`;
                        (e = s(e)),
                            (this.wrapper = e.querySelector(".modal-wrapper")),
                            (this.wrapper.style.opacity = 0),
                            (this.mask = e.querySelector(".modal-mask")),
                            (this.content = s(this.content)),
                            (this.contentWrapper = e.querySelector(".modal-content")),
                            (this.contentWrapper.style.opacity = 0),
                            this.contentWrapper.appendChild(this.content),
                            e.querySelectorAll(".modal-close").forEach((e) => {
                                e.addEventListener("click", (e) => {
                                    e.preventDefault(), this.close();
                                });
                            }),
                            document.body.appendChild(e);
                    }
                    window.innerWidth, document.body.clientWidth;
                    document.body.classList.add("body-masked"),
                        (this.wrapper.style.display = "block"),
                        (this.wrapper.animate([{ opacity: 0 }, { opacity: 1 }], 300).onfinish = (e) => {
                            e.target.effect.target.style.opacity = 1;
                        }),
                        (this.contentWrapper.animate(
                            [
                                { transform: "translateY(100px)", opacity: 0 },
                                { transform: "translateY(0px)", opacity: 1 },
                            ],
                            300
                        ).onfinish = (t) => {
                            (t.target.effect.target.style.transform = "translateY(0px)"), (t.target.effect.target.style.opacity = 1), this.next({ type: "open:rendered" }), e();
                        });
                })
            );
        }
        close() {
            (this.active = !1),
                this.next({ type: "close" }),
                (this.wrapper.animate([{ opacity: 1 }, { opacity: 0 }], 200).onfinish = (e) => {
                    (e.target.effect.target.style.opacity = 0), document.body.classList.remove("body-masked"), (document.body.style.paddingRight = "0px"), (this.wrapper.style.display = "none");
                }),
                (this.contentWrapper.animate(
                    [
                        { transform: "scale(1)", opacity: 1 },
                        { transform: "scale(1.2)", opacity: 0 },
                    ],
                    200
                ).onfinish = (e) => {
                    (e.target.effect.target.style.opacity = 0), this.next({ type: "close:finish" });
                });
        }
        destroy() {
            this.wrapper.remove();
        }
    }
    function i(e) {
        e = e || window.location;
        const t = {},
            s = document.createElement("a");
        s.href = e;
        for (let e = s.search.substring(1).split("&"), i = 0; i < e.length; i++) {
            let s = e[i].split("=");
            t[s[0]] = decodeURIComponent(s[1]);
        }
        return t;
    }
    class GlobliazationHelper {
        constructor(e) {
            (this.id = Math.floor(999999999999 * Math.random())),
                (this.lsKey = "wbsk_gf_gb_key"),
                (this.ObserverLite = new ObserverLite()),
                (this.default = e.default),
                (this.territories = e.territories),
                (this.active = e.init ? this.getLocation({ key: "url", value: e.init }) : this.territories[0]);
            i().relocate && this.setLs("hideUiOnInit", !0);
            this.getLs().hideUiOnInit ||
                this.getUserLocationData().then((e) => {
                    const t = e.country_code;
                    if (t) {
                        let e = this.territories.filter(({ codes: e }) => e && e.split(",").indexOf(t) >= 0);
                        (e = !!e.length && e[0]),
                            e &&
                                e.title != this.active.title &&
                                this.default.show &&
                                setTimeout(() => {
                                    this.setLs("hideUiOnInit", !0), this.next({ eventType: "showToggleUi" });
                                }, 4e3);
                    }
                });
        }
        subscribe(e) {
            return this.ObserverLite.subscribe(e);
        }
        next(e) {
            this.ObserverLite.next(e);
        }
        setLs(e, t) {
            let s = window.localStorage.getItem(this.lsKey) ? JSON.parse(window.localStorage.getItem(this.lsKey)) : {};
            (s[e] = t), (s = JSON.stringify(s)), window.localStorage.setItem(this.lsKey, s);
        }
        getLs() {
            return window.localStorage.getItem(this.lsKey) ? JSON.parse(window.localStorage.getItem(this.lsKey)) : {};
        }
        getLocation({ key: e, value: t }) {
            let s = this.territories.filter((s) => s[e] && s[e] == t);
            return s.length ? s[0] : this.territories[0];
        }
        updateActive({ key: e, value: t }) {
            e && t && ((this.active = this.getLocation({ key: e, value: t })), this.next({}));
        }
        getUserLocationData() {
            return new Promise((e, t) => {
                fetch("https://api.ipstack.com/check?access_key=063aaa22b222b3c5d88ac17d615f016b")
                    .then((e) => e.json())
                    .then((t) => e(t))
                    .catch((e) => {
                        console.log(e);
                    });
            });
        }
    }
    class ShopifyUtils {
        constructor() {
            this.money_format = moneyfomat;
        }
        handleize(e) {
            return e
                .toLowerCase()
                .replace(/[^\w\u00C0-\u024f]+/g, "-")
                .replace(/^-+|-+$/g, "");
        }
        parseImgUrl(e, t) {
            const s = e.includes(".png") ? "png" : "jpg";
            return `${e.split("png" == s ? ".png" : ".jpg")[0]}_${t}x.${s}`;
        }
        formatMoney(e, t) {
            "string" == typeof e && (e = e.replace(".", ""));
            var s = "",
                i = /\{\{\s*(\w+)\s*\}\}/,
                r = t || this.money_format;
            function a(e, t) {
                return void 0 === e ? t : e;
            }
            function n(e, t, s, i) {
                if (((t = a(t, 2)), (s = a(s, ",")), (i = a(i, ".")), isNaN(e) || null == e)) return 0;
                var r = (e = (e / 100).toFixed(t)).split(".");
                return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + s) + (r[1] ? i + r[1] : "");
            }
            switch (r.match(i)[1]) {
                case "amount":
                    s = n(e, 2);
                    break;
                case "amount_no_decimals":
                    s = n(e, 0);
                    break;
                case "amount_with_comma_separator":
                    s = n(e, 2, ".", ",");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    s = n(e, 0, ".", ",");
            }
            return r.replace(i, s);
        }
    }
    function r() {
        return new Promise(function (e, t) {
            "loading" !== document.readyState
                ? e()
                : addEventListener("DOMContentLoaded", () => {
                      e();
                  });
        });
    }
    class GlobalCart {
        constructor(e) {
            return (
                (window.GlobalCartObserver$ = window.GlobalCartObserver$ || new ObserverLite()),
                window.GlobalCartSingleton
                    ? new Promise((e, t) => {
                          window.GlobalCartObserver$.loaded
                              ? e(window.GlobalCartSingleton)
                              : window.GlobalCartObserver$.subscribe(() => {
                                    e(window.GlobalCartSingleton);
                                });
                      })
                    : e
                    ? ((window.GlobalCartSingleton = this),
                      (this.ObserverLite = new ObserverLite()),
                      (this.ShopifyUtils = new ShopifyUtils({ money_format: e.money_format || !1 })),
                      this.subscribe(() => {
                          (window.GlobalCartObserver$.loaded = !0), window.GlobalCartObserver$.next();
                      }),
                      void this.updateData())
                    : new Promise((e, t) => {
                          window.GlobalCartObserver$.subscribe(() => {
                              e(window.GlobalCartSingleton);
                          });
                      })
            );
        }
        subscribe(e) {
            return this.ObserverLite.subscribe(e);
        }
        next(e) {
            this.ObserverLite.next(e);
        }
        serialize(e) {
            const t = {};
            function s(e, t, s) {
                const i = t.pop();
                let r = e;
                for (const e of t) r[e] || (r[e] = {}), (r = r[e]);
                r[i] = s;
            }
            const i = new FormData(e);
            for (let [e, r] of i.entries()) {
                s(
                    t,
                    e.split("[").map((e) => e.replace("]", "")),
                    r
                );
            }
            return t;
        }
        addViaForm(e) {
            let t = this.serialize(e);
            return (t.quantity = parseInt(t.quantity)), (t = { items: [t] }), this.addToCart(t);
        }
        addToCart(e) {
            return new Promise((t, s) => {
                e || s({ description: "Sorry, there was a problem with that request" }),
                    fetch("/cart/add.js", { method: "POST", body: JSON.stringify(e), headers: { "Content-Type": "application/json" } })
                        .then((e) => e.json())
                        .then((e) => {
                            if (!e) throw e;
                            this.updateData(), t();
                        })
                        .catch((e) => {
                            console.log(e), s(e);
                        });
            });
        }
        updateData() {
            return new Promise((e, t) => {
                this.getCartJSON().then((t) => {
                    (this.cart = t), this.next({ eventType: "update" }), e();
                });
            });
        }
        updateQty(e, t) {
            let s = [{ key: e.key, qty: t }];
            console.log(s),
                fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ updates: s.reduce((e, t) => ({ ...e, [t.key]: t.qty }), {}) }) })
                    .then((e) => e.json())
                    .then((e) => {
                        if (!e.token) throw e;
                        this.updateData().then(() => {
                            this.next({ eventType: "update" });
                        });
                    })
                    .catch((e) => {
                        this.next({ eventType: "error", error: e });
                    });
        }
        removeItem(e) {
            fetch(e).then((e) => {
                this.updateData().then(() => {
                    this.next({ eventType: "update" });
                });
            });
        }
        getCartJSON() {
            return new Promise((e, t) => {
                fetch("/cart.js")
                    .then((e) => e.json())
                    .then((t) => {
                        e(t);
                    });
            });
        }
        getLineItemsByVariantId(e) {
            return (e = parseInt(e)), this.cart && this.cart.items ? this.cart.items.filter(({ variant_id: t }) => t == e) : [];
        }
        getLineItemsByProperty(e, t) {
            return this.cart && this.cart.items
                ? this.cart.items.filter((s) => {
                      let i = s.properties?.[e];
                      return (i = !!((null == t && i) || (i && i == t))), i;
                  })
                : [];
        }
    }
    function a(e) {
        return null !== e && "object" == typeof e && "constructor" in e && e.constructor === Object;
    }
    function n(e = {}, t = {}) {
        Object.keys(t).forEach((s) => {
            void 0 === e[s] ? (e[s] = t[s]) : a(t[s]) && a(e[s]) && Object.keys(t[s]).length > 0 && n(e[s], t[s]);
        });
    }
    const l = {
        body: {},
        addEventListener() {},
        removeEventListener() {},
        activeElement: { blur() {}, nodeName: "" },
        querySelector: () => null,
        querySelectorAll: () => [],
        getElementById: () => null,
        createEvent: () => ({ initEvent() {} }),
        createElement: () => ({ children: [], childNodes: [], style: {}, setAttribute() {}, getElementsByTagName: () => [] }),
        createElementNS: () => ({}),
        importNode: () => null,
        location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
    };
    function o() {
        const e = "undefined" != typeof document ? document : {};
        return n(e, l), e;
    }
    const c = {
        document: l,
        navigator: { userAgent: "" },
        location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
        history: { replaceState() {}, pushState() {}, go() {}, back() {} },
        CustomEvent: function () {
            return this;
        },
        addEventListener() {},
        removeEventListener() {},
        getComputedStyle: () => ({ getPropertyValue: () => "" }),
        Image() {},
        Date() {},
        screen: {},
        setTimeout() {},
        clearTimeout() {},
        matchMedia: () => ({}),
        requestAnimationFrame: (e) => ("undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0)),
        cancelAnimationFrame(e) {
            "undefined" != typeof setTimeout && clearTimeout(e);
        },
    };
    function d() {
        const e = "undefined" != typeof window ? window : {};
        return n(e, c), e;
    }
    function p(e, t = 0) {
        return setTimeout(e, t);
    }
    function u() {
        return Date.now();
    }
    function h(e, t = "x") {
        const s = d();
        let i, r, a;
        const n = (function (e) {
            const t = d();
            let s;
            return t.getComputedStyle && (s = t.getComputedStyle(e, null)), !s && e.currentStyle && (s = e.currentStyle), s || (s = e.style), s;
        })(e);
        return (
            s.WebKitCSSMatrix
                ? ((r = n.transform || n.webkitTransform),
                  r.split(",").length > 6 &&
                      (r = r
                          .split(", ")
                          .map((e) => e.replace(",", "."))
                          .join(", ")),
                  (a = new s.WebKitCSSMatrix("none" === r ? "" : r)))
                : ((a = n.MozTransform || n.OTransform || n.MsTransform || n.msTransform || n.transform || n.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")), (i = a.toString().split(","))),
            "x" === t && (r = s.WebKitCSSMatrix ? a.m41 : 16 === i.length ? parseFloat(i[12]) : parseFloat(i[4])),
            "y" === t && (r = s.WebKitCSSMatrix ? a.m42 : 16 === i.length ? parseFloat(i[13]) : parseFloat(i[5])),
            r || 0
        );
    }
    function m(e) {
        return "object" == typeof e && null !== e && e.constructor && "Object" === Object.prototype.toString.call(e).slice(8, -1);
    }
    function g(...e) {
        const t = Object(e[0]),
            s = ["__proto__", "constructor", "prototype"];
        for (let r = 1; r < e.length; r += 1) {
            const a = e[r];
            if (null != a && ((i = a), !("undefined" != typeof window && void 0 !== window.HTMLElement ? i instanceof HTMLElement : i && (1 === i.nodeType || 11 === i.nodeType)))) {
                const e = Object.keys(Object(a)).filter((e) => s.indexOf(e) < 0);
                for (let s = 0, i = e.length; s < i; s += 1) {
                    const i = e[s],
                        r = Object.getOwnPropertyDescriptor(a, i);
                    void 0 !== r && r.enumerable && (m(t[i]) && m(a[i]) ? (a[i].__swiper__ ? (t[i] = a[i]) : g(t[i], a[i])) : !m(t[i]) && m(a[i]) ? ((t[i] = {}), a[i].__swiper__ ? (t[i] = a[i]) : g(t[i], a[i])) : (t[i] = a[i]));
                }
            }
        }
        var i;
        return t;
    }
    function f(e, t, s) {
        e.style.setProperty(t, s);
    }
    function b({ swiper: e, targetPosition: t, side: s }) {
        const i = d(),
            r = -e.translate;
        let a,
            n = null;
        const l = e.params.speed;
        (e.wrapperEl.style.scrollSnapType = "none"), i.cancelAnimationFrame(e.cssModeFrameID);
        const o = t > r ? "next" : "prev",
            c = (e, t) => ("next" === o && e >= t) || ("prev" === o && e <= t),
            p = () => {
                (a = new Date().getTime()), null === n && (n = a);
                const o = Math.max(Math.min((a - n) / l, 1), 0),
                    d = 0.5 - Math.cos(o * Math.PI) / 2;
                let u = r + d * (t - r);
                if ((c(u, t) && (u = t), e.wrapperEl.scrollTo({ [s]: u }), c(u, t)))
                    return (
                        (e.wrapperEl.style.overflow = "hidden"),
                        (e.wrapperEl.style.scrollSnapType = ""),
                        setTimeout(() => {
                            (e.wrapperEl.style.overflow = ""), e.wrapperEl.scrollTo({ [s]: u });
                        }),
                        void i.cancelAnimationFrame(e.cssModeFrameID)
                    );
                e.cssModeFrameID = i.requestAnimationFrame(p);
            };
        p();
    }
    function v(e, t = "") {
        return [...e.children].filter((e) => e.matches(t));
    }
    function w(e, t = []) {
        const s = document.createElement(e);
        return s.classList.add(...(Array.isArray(t) ? t : [t])), s;
    }
    function y(e, t) {
        return d().getComputedStyle(e, null).getPropertyValue(t);
    }
    function S(e) {
        let t,
            s = e;
        if (s) {
            for (t = 0; null !== (s = s.previousSibling); ) 1 === s.nodeType && (t += 1);
            return t;
        }
    }
    function A(e, t) {
        const s = [];
        let i = e.parentElement;
        for (; i; ) t ? i.matches(t) && s.push(i) : s.push(i), (i = i.parentElement);
        return s;
    }
    function E(e, t, s) {
        const i = d();
        return s
            ? e["width" === t ? "offsetWidth" : "offsetHeight"] +
                  parseFloat(i.getComputedStyle(e, null).getPropertyValue("width" === t ? "margin-right" : "margin-top")) +
                  parseFloat(i.getComputedStyle(e, null).getPropertyValue("width" === t ? "margin-left" : "margin-bottom"))
            : e.offsetWidth;
    }
    let x, C, T;
    function L() {
        return (
            x ||
                (x = (function () {
                    const e = d(),
                        t = o();
                    return { smoothScroll: t.documentElement && t.documentElement.style && "scrollBehavior" in t.documentElement.style, touch: !!("ontouchstart" in e || (e.DocumentTouch && t instanceof e.DocumentTouch)) };
                })()),
            x
        );
    }
    function k(e = {}) {
        return (
            C ||
                (C = (function ({ userAgent: e } = {}) {
                    const t = L(),
                        s = d(),
                        i = s.navigator.platform,
                        r = e || s.navigator.userAgent,
                        a = { ios: !1, android: !1 },
                        n = s.screen.width,
                        l = s.screen.height,
                        o = r.match(/(Android);?[\s\/]+([\d.]+)?/);
                    let c = r.match(/(iPad).*OS\s([\d_]+)/);
                    const p = r.match(/(iPod)(.*OS\s([\d_]+))?/),
                        u = !c && r.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
                        h = "Win32" === i;
                    let m = "MacIntel" === i;
                    return (
                        !c &&
                            m &&
                            t.touch &&
                            ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"].indexOf(`${n}x${l}`) >= 0 &&
                            ((c = r.match(/(Version)\/([\d.]+)/)), c || (c = [0, 1, "13_0_0"]), (m = !1)),
                        o && !h && ((a.os = "android"), (a.android = !0)),
                        (c || u || p) && ((a.os = "ios"), (a.ios = !0)),
                        a
                    );
                })(e)),
            C
        );
    }
    function M() {
        return (
            T ||
                (T = (function () {
                    const e = d();
                    let t = !1;
                    function s() {
                        const t = e.navigator.userAgent.toLowerCase();
                        return t.indexOf("safari") >= 0 && t.indexOf("chrome") < 0 && t.indexOf("android") < 0;
                    }
                    if (s()) {
                        const s = String(e.navigator.userAgent);
                        if (s.includes("Version/")) {
                            const [e, i] = s
                                .split("Version/")[1]
                                .split(" ")[0]
                                .split(".")
                                .map((e) => Number(e));
                            t = e < 16 || (16 === e && i < 2);
                        }
                    }
                    return { isSafari: t || s(), needPerspectiveFix: t, isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent) };
                })()),
            T
        );
    }
    const O = {
        on(e, t, s) {
            const i = this;
            if (!i.eventsListeners || i.destroyed) return i;
            if ("function" != typeof t) return i;
            const r = s ? "unshift" : "push";
            return (
                e.split(" ").forEach((e) => {
                    i.eventsListeners[e] || (i.eventsListeners[e] = []), i.eventsListeners[e][r](t);
                }),
                i
            );
        },
        once(e, t, s) {
            const i = this;
            if (!i.eventsListeners || i.destroyed) return i;
            if ("function" != typeof t) return i;
            function r(...s) {
                i.off(e, r), r.__emitterProxy && delete r.__emitterProxy, t.apply(i, s);
            }
            return (r.__emitterProxy = t), i.on(e, r, s);
        },
        onAny(e, t) {
            const s = this;
            if (!s.eventsListeners || s.destroyed) return s;
            if ("function" != typeof e) return s;
            const i = t ? "unshift" : "push";
            return s.eventsAnyListeners.indexOf(e) < 0 && s.eventsAnyListeners[i](e), s;
        },
        offAny(e) {
            const t = this;
            if (!t.eventsListeners || t.destroyed) return t;
            if (!t.eventsAnyListeners) return t;
            const s = t.eventsAnyListeners.indexOf(e);
            return s >= 0 && t.eventsAnyListeners.splice(s, 1), t;
        },
        off(e, t) {
            const s = this;
            return !s.eventsListeners || s.destroyed
                ? s
                : s.eventsListeners
                ? (e.split(" ").forEach((e) => {
                      void 0 === t
                          ? (s.eventsListeners[e] = [])
                          : s.eventsListeners[e] &&
                            s.eventsListeners[e].forEach((i, r) => {
                                (i === t || (i.__emitterProxy && i.__emitterProxy === t)) && s.eventsListeners[e].splice(r, 1);
                            });
                  }),
                  s)
                : s;
        },
        emit(...e) {
            const t = this;
            if (!t.eventsListeners || t.destroyed) return t;
            if (!t.eventsListeners) return t;
            let s, i, r;
            "string" == typeof e[0] || Array.isArray(e[0]) ? ((s = e[0]), (i = e.slice(1, e.length)), (r = t)) : ((s = e[0].events), (i = e[0].data), (r = e[0].context || t)), i.unshift(r);
            return (
                (Array.isArray(s) ? s : s.split(" ")).forEach((e) => {
                    t.eventsAnyListeners &&
                        t.eventsAnyListeners.length &&
                        t.eventsAnyListeners.forEach((t) => {
                            t.apply(r, [e, ...i]);
                        }),
                        t.eventsListeners &&
                            t.eventsListeners[e] &&
                            t.eventsListeners[e].forEach((e) => {
                                e.apply(r, i);
                            });
                }),
                t
            );
        },
    };
    const P = (e, t) => {
            if (!e || e.destroyed || !e.params) return;
            const s = t.closest(e.isElement ? "swiper-slide" : `.${e.params.slideClass}`);
            if (s) {
                const t = s.querySelector(`.${e.params.lazyPreloaderClass}`);
                t && t.remove();
            }
        },
        _ = (e, t) => {
            if (!e.slides[t]) return;
            const s = e.slides[t].querySelector('[loading="lazy"]');
            s && s.removeAttribute("loading");
        },
        G = (e) => {
            if (!e || e.destroyed || !e.params) return;
            let t = e.params.lazyPreloadPrevNext;
            const s = e.slides.length;
            if (!s || !t || t < 0) return;
            t = Math.min(t, s);
            const i = "auto" === e.params.slidesPerView ? e.slidesPerViewDynamic() : Math.ceil(e.params.slidesPerView),
                r = e.activeIndex;
            if (e.params.grid && e.params.grid.rows > 1) {
                const s = r,
                    a = [s - t];
                return (
                    a.push(...Array.from({ length: t }).map((e, t) => s + i + t)),
                    void e.slides.forEach((t, s) => {
                        a.includes(t.column) && _(e, s);
                    })
                );
            }
            const a = r + i - 1;
            if (e.params.rewind || e.params.loop)
                for (let i = r - t; i <= a + t; i += 1) {
                    const t = ((i % s) + s) % s;
                    (t < r || t > a) && _(e, t);
                }
            else for (let i = Math.max(r - t, 0); i <= Math.min(a + t, s - 1); i += 1) i !== r && (i > a || i < r) && _(e, i);
        };
    const z = {
        updateSize: function () {
            const e = this;
            let t, s;
            const i = e.el;
            (t = void 0 !== e.params.width && null !== e.params.width ? e.params.width : i.clientWidth),
                (s = void 0 !== e.params.height && null !== e.params.height ? e.params.height : i.clientHeight),
                (0 === t && e.isHorizontal()) ||
                    (0 === s && e.isVertical()) ||
                    ((t = t - parseInt(y(i, "padding-left") || 0, 10) - parseInt(y(i, "padding-right") || 0, 10)),
                    (s = s - parseInt(y(i, "padding-top") || 0, 10) - parseInt(y(i, "padding-bottom") || 0, 10)),
                    Number.isNaN(t) && (t = 0),
                    Number.isNaN(s) && (s = 0),
                    Object.assign(e, { width: t, height: s, size: e.isHorizontal() ? t : s }));
        },
        updateSlides: function () {
            const e = this;
            function t(t) {
                return e.isHorizontal()
                    ? t
                    : {
                          width: "height",
                          "margin-top": "margin-left",
                          "margin-bottom ": "margin-right",
                          "margin-left": "margin-top",
                          "margin-right": "margin-bottom",
                          "padding-left": "padding-top",
                          "padding-right": "padding-bottom",
                          marginRight: "marginBottom",
                      }[t];
            }
            function s(e, s) {
                return parseFloat(e.getPropertyValue(t(s)) || 0);
            }
            const i = e.params,
                { wrapperEl: r, slidesEl: a, size: n, rtlTranslate: l, wrongRTL: o } = e,
                c = e.virtual && i.virtual.enabled,
                d = c ? e.virtual.slides.length : e.slides.length,
                p = v(a, `.${e.params.slideClass}, swiper-slide`),
                u = c ? e.virtual.slides.length : p.length;
            let h = [];
            const m = [],
                g = [];
            let b = i.slidesOffsetBefore;
            "function" == typeof b && (b = i.slidesOffsetBefore.call(e));
            let w = i.slidesOffsetAfter;
            "function" == typeof w && (w = i.slidesOffsetAfter.call(e));
            const S = e.snapGrid.length,
                A = e.slidesGrid.length;
            let x = i.spaceBetween,
                C = -b,
                T = 0,
                L = 0;
            if (void 0 === n) return;
            "string" == typeof x && x.indexOf("%") >= 0 ? (x = (parseFloat(x.replace("%", "")) / 100) * n) : "string" == typeof x && (x = parseFloat(x)),
                (e.virtualSize = -x),
                p.forEach((e) => {
                    l ? (e.style.marginLeft = "") : (e.style.marginRight = ""), (e.style.marginBottom = ""), (e.style.marginTop = "");
                }),
                i.centeredSlides && i.cssMode && (f(r, "--swiper-centered-offset-before", ""), f(r, "--swiper-centered-offset-after", ""));
            const k = i.grid && i.grid.rows > 1 && e.grid;
            let M;
            k && e.grid.initSlides(u);
            const O = "auto" === i.slidesPerView && i.breakpoints && Object.keys(i.breakpoints).filter((e) => void 0 !== i.breakpoints[e].slidesPerView).length > 0;
            for (let r = 0; r < u; r += 1) {
                let a;
                if (((M = 0), p[r] && (a = p[r]), k && e.grid.updateSlide(r, a, u, t), !p[r] || "none" !== y(a, "display"))) {
                    if ("auto" === i.slidesPerView) {
                        O && (p[r].style[t("width")] = "");
                        const n = getComputedStyle(a),
                            l = a.style.transform,
                            o = a.style.webkitTransform;
                        if ((l && (a.style.transform = "none"), o && (a.style.webkitTransform = "none"), i.roundLengths)) M = e.isHorizontal() ? E(a, "width", !0) : E(a, "height", !0);
                        else {
                            const e = s(n, "width"),
                                t = s(n, "padding-left"),
                                i = s(n, "padding-right"),
                                r = s(n, "margin-left"),
                                l = s(n, "margin-right"),
                                o = n.getPropertyValue("box-sizing");
                            if (o && "border-box" === o) M = e + r + l;
                            else {
                                const { clientWidth: s, offsetWidth: n } = a;
                                M = e + t + i + r + l + (n - s);
                            }
                        }
                        l && (a.style.transform = l), o && (a.style.webkitTransform = o), i.roundLengths && (M = Math.floor(M));
                    } else (M = (n - (i.slidesPerView - 1) * x) / i.slidesPerView), i.roundLengths && (M = Math.floor(M)), p[r] && (p[r].style[t("width")] = `${M}px`);
                    p[r] && (p[r].swiperSlideSize = M),
                        g.push(M),
                        i.centeredSlides
                            ? ((C = C + M / 2 + T / 2 + x),
                              0 === T && 0 !== r && (C = C - n / 2 - x),
                              0 === r && (C = C - n / 2 - x),
                              Math.abs(C) < 0.001 && (C = 0),
                              i.roundLengths && (C = Math.floor(C)),
                              L % i.slidesPerGroup == 0 && h.push(C),
                              m.push(C))
                            : (i.roundLengths && (C = Math.floor(C)), (L - Math.min(e.params.slidesPerGroupSkip, L)) % e.params.slidesPerGroup == 0 && h.push(C), m.push(C), (C = C + M + x)),
                        (e.virtualSize += M + x),
                        (T = M),
                        (L += 1);
                }
            }
            if (
                ((e.virtualSize = Math.max(e.virtualSize, n) + w),
                l && o && ("slide" === i.effect || "coverflow" === i.effect) && (r.style.width = `${e.virtualSize + x}px`),
                i.setWrapperSize && (r.style[t("width")] = `${e.virtualSize + x}px`),
                k && e.grid.updateWrapperSize(M, h, t),
                !i.centeredSlides)
            ) {
                const t = [];
                for (let s = 0; s < h.length; s += 1) {
                    let r = h[s];
                    i.roundLengths && (r = Math.floor(r)), h[s] <= e.virtualSize - n && t.push(r);
                }
                (h = t), Math.floor(e.virtualSize - n) - Math.floor(h[h.length - 1]) > 1 && h.push(e.virtualSize - n);
            }
            if (c && i.loop) {
                const t = g[0] + x;
                if (i.slidesPerGroup > 1) {
                    const s = Math.ceil((e.virtual.slidesBefore + e.virtual.slidesAfter) / i.slidesPerGroup),
                        r = t * i.slidesPerGroup;
                    for (let e = 0; e < s; e += 1) h.push(h[h.length - 1] + r);
                }
                for (let s = 0; s < e.virtual.slidesBefore + e.virtual.slidesAfter; s += 1) 1 === i.slidesPerGroup && h.push(h[h.length - 1] + t), m.push(m[m.length - 1] + t), (e.virtualSize += t);
            }
            if ((0 === h.length && (h = [0]), 0 !== x)) {
                const s = e.isHorizontal() && l ? "marginLeft" : t("marginRight");
                p.filter((e, t) => !(i.cssMode && !i.loop) || t !== p.length - 1).forEach((e) => {
                    e.style[s] = `${x}px`;
                });
            }
            if (i.centeredSlides && i.centeredSlidesBounds) {
                let e = 0;
                g.forEach((t) => {
                    e += t + (x || 0);
                }),
                    (e -= x);
                const t = e - n;
                h = h.map((e) => (e <= 0 ? -b : e > t ? t + w : e));
            }
            if (i.centerInsufficientSlides) {
                let e = 0;
                if (
                    (g.forEach((t) => {
                        e += t + (x || 0);
                    }),
                    (e -= x),
                    e < n)
                ) {
                    const t = (n - e) / 2;
                    h.forEach((e, s) => {
                        h[s] = e - t;
                    }),
                        m.forEach((e, s) => {
                            m[s] = e + t;
                        });
                }
            }
            if ((Object.assign(e, { slides: p, snapGrid: h, slidesGrid: m, slidesSizesGrid: g }), i.centeredSlides && i.cssMode && !i.centeredSlidesBounds)) {
                f(r, "--swiper-centered-offset-before", -h[0] + "px"), f(r, "--swiper-centered-offset-after", e.size / 2 - g[g.length - 1] / 2 + "px");
                const t = -e.snapGrid[0],
                    s = -e.slidesGrid[0];
                (e.snapGrid = e.snapGrid.map((e) => e + t)), (e.slidesGrid = e.slidesGrid.map((e) => e + s));
            }
            if (
                (u !== d && e.emit("slidesLengthChange"),
                h.length !== S && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")),
                m.length !== A && e.emit("slidesGridLengthChange"),
                i.watchSlidesProgress && e.updateSlidesOffset(),
                !(c || i.cssMode || ("slide" !== i.effect && "fade" !== i.effect)))
            ) {
                const t = `${i.containerModifierClass}backface-hidden`,
                    s = e.el.classList.contains(t);
                u <= i.maxBackfaceHiddenSlides ? s || e.el.classList.add(t) : s && e.el.classList.remove(t);
            }
        },
        updateAutoHeight: function (e) {
            const t = this,
                s = [],
                i = t.virtual && t.params.virtual.enabled;
            let r,
                a = 0;
            "number" == typeof e ? t.setTransition(e) : !0 === e && t.setTransition(t.params.speed);
            const n = (e) => (i ? t.slides[t.getSlideIndexByData(e)] : t.slides[e]);
            if ("auto" !== t.params.slidesPerView && t.params.slidesPerView > 1)
                if (t.params.centeredSlides)
                    (t.visibleSlides || []).forEach((e) => {
                        s.push(e);
                    });
                else
                    for (r = 0; r < Math.ceil(t.params.slidesPerView); r += 1) {
                        const e = t.activeIndex + r;
                        if (e > t.slides.length && !i) break;
                        s.push(n(e));
                    }
            else s.push(n(t.activeIndex));
            for (r = 0; r < s.length; r += 1)
                if (void 0 !== s[r]) {
                    const e = s[r].offsetHeight;
                    a = e > a ? e : a;
                }
            (a || 0 === a) && (t.wrapperEl.style.height = `${a}px`);
        },
        updateSlidesOffset: function () {
            const e = this,
                t = e.slides,
                s = e.isElement ? (e.isHorizontal() ? e.wrapperEl.offsetLeft : e.wrapperEl.offsetTop) : 0;
            for (let i = 0; i < t.length; i += 1) t[i].swiperSlideOffset = (e.isHorizontal() ? t[i].offsetLeft : t[i].offsetTop) - s - e.cssOverflowAdjustment();
        },
        updateSlidesProgress: function (e = (this && this.translate) || 0) {
            const t = this,
                s = t.params,
                { slides: i, rtlTranslate: r, snapGrid: a } = t;
            if (0 === i.length) return;
            void 0 === i[0].swiperSlideOffset && t.updateSlidesOffset();
            let n = -e;
            r && (n = e),
                i.forEach((e) => {
                    e.classList.remove(s.slideVisibleClass);
                }),
                (t.visibleSlidesIndexes = []),
                (t.visibleSlides = []);
            let l = s.spaceBetween;
            "string" == typeof l && l.indexOf("%") >= 0 ? (l = (parseFloat(l.replace("%", "")) / 100) * t.size) : "string" == typeof l && (l = parseFloat(l));
            for (let e = 0; e < i.length; e += 1) {
                const o = i[e];
                let c = o.swiperSlideOffset;
                s.cssMode && s.centeredSlides && (c -= i[0].swiperSlideOffset);
                const d = (n + (s.centeredSlides ? t.minTranslate() : 0) - c) / (o.swiperSlideSize + l),
                    p = (n - a[0] + (s.centeredSlides ? t.minTranslate() : 0) - c) / (o.swiperSlideSize + l),
                    u = -(n - c),
                    h = u + t.slidesSizesGrid[e];
                ((u >= 0 && u < t.size - 1) || (h > 1 && h <= t.size) || (u <= 0 && h >= t.size)) && (t.visibleSlides.push(o), t.visibleSlidesIndexes.push(e), i[e].classList.add(s.slideVisibleClass)),
                    (o.progress = r ? -d : d),
                    (o.originalProgress = r ? -p : p);
            }
        },
        updateProgress: function (e) {
            const t = this;
            if (void 0 === e) {
                const s = t.rtlTranslate ? -1 : 1;
                e = (t && t.translate && t.translate * s) || 0;
            }
            const s = t.params,
                i = t.maxTranslate() - t.minTranslate();
            let { progress: r, isBeginning: a, isEnd: n, progressLoop: l } = t;
            const o = a,
                c = n;
            if (0 === i) (r = 0), (a = !0), (n = !0);
            else {
                r = (e - t.minTranslate()) / i;
                const s = Math.abs(e - t.minTranslate()) < 1,
                    l = Math.abs(e - t.maxTranslate()) < 1;
                (a = s || r <= 0), (n = l || r >= 1), s && (r = 0), l && (r = 1);
            }
            if (s.loop) {
                const s = t.getSlideIndexByData(0),
                    i = t.getSlideIndexByData(t.slides.length - 1),
                    r = t.slidesGrid[s],
                    a = t.slidesGrid[i],
                    n = t.slidesGrid[t.slidesGrid.length - 1],
                    o = Math.abs(e);
                (l = o >= r ? (o - r) / n : (o + n - a) / n), l > 1 && (l -= 1);
            }
            Object.assign(t, { progress: r, progressLoop: l, isBeginning: a, isEnd: n }),
                (s.watchSlidesProgress || (s.centeredSlides && s.autoHeight)) && t.updateSlidesProgress(e),
                a && !o && t.emit("reachBeginning toEdge"),
                n && !c && t.emit("reachEnd toEdge"),
                ((o && !a) || (c && !n)) && t.emit("fromEdge"),
                t.emit("progress", r);
        },
        updateSlidesClasses: function () {
            const e = this,
                { slides: t, params: s, slidesEl: i, activeIndex: r } = e,
                a = e.virtual && s.virtual.enabled,
                n = (e) => v(i, `.${s.slideClass}${e}, swiper-slide${e}`)[0];
            let l;
            if (
                (t.forEach((e) => {
                    e.classList.remove(s.slideActiveClass, s.slideNextClass, s.slidePrevClass);
                }),
                a)
            )
                if (s.loop) {
                    let t = r - e.virtual.slidesBefore;
                    t < 0 && (t = e.virtual.slides.length + t), t >= e.virtual.slides.length && (t -= e.virtual.slides.length), (l = n(`[data-swiper-slide-index="${t}"]`));
                } else l = n(`[data-swiper-slide-index="${r}"]`);
            else l = t[r];
            if (l) {
                l.classList.add(s.slideActiveClass);
                let e = (function (e, t) {
                    const s = [];
                    for (; e.nextElementSibling; ) {
                        const i = e.nextElementSibling;
                        t ? i.matches(t) && s.push(i) : s.push(i), (e = i);
                    }
                    return s;
                })(l, `.${s.slideClass}, swiper-slide`)[0];
                s.loop && !e && (e = t[0]), e && e.classList.add(s.slideNextClass);
                let i = (function (e, t) {
                    const s = [];
                    for (; e.previousElementSibling; ) {
                        const i = e.previousElementSibling;
                        t ? i.matches(t) && s.push(i) : s.push(i), (e = i);
                    }
                    return s;
                })(l, `.${s.slideClass}, swiper-slide`)[0];
                s.loop && 0 === !i && (i = t[t.length - 1]), i && i.classList.add(s.slidePrevClass);
            }
            e.emitSlidesClasses();
        },
        updateActiveIndex: function (e) {
            const t = this,
                s = t.rtlTranslate ? t.translate : -t.translate,
                { snapGrid: i, params: r, activeIndex: a, realIndex: n, snapIndex: l } = t;
            let o,
                c = e;
            const d = (e) => {
                let s = e - t.virtual.slidesBefore;
                return s < 0 && (s = t.virtual.slides.length + s), s >= t.virtual.slides.length && (s -= t.virtual.slides.length), s;
            };
            if (
                (void 0 === c &&
                    (c = (function (e) {
                        const { slidesGrid: t, params: s } = e,
                            i = e.rtlTranslate ? e.translate : -e.translate;
                        let r;
                        for (let e = 0; e < t.length; e += 1) void 0 !== t[e + 1] ? (i >= t[e] && i < t[e + 1] - (t[e + 1] - t[e]) / 2 ? (r = e) : i >= t[e] && i < t[e + 1] && (r = e + 1)) : i >= t[e] && (r = e);
                        return s.normalizeSlideIndex && (r < 0 || void 0 === r) && (r = 0), r;
                    })(t)),
                i.indexOf(s) >= 0)
            )
                o = i.indexOf(s);
            else {
                const e = Math.min(r.slidesPerGroupSkip, c);
                o = e + Math.floor((c - e) / r.slidesPerGroup);
            }
            if ((o >= i.length && (o = i.length - 1), c === a)) return o !== l && ((t.snapIndex = o), t.emit("snapIndexChange")), void (t.params.loop && t.virtual && t.params.virtual.enabled && (t.realIndex = d(c)));
            let p;
            (p = t.virtual && r.virtual.enabled && r.loop ? d(c) : t.slides[c] ? parseInt(t.slides[c].getAttribute("data-swiper-slide-index") || c, 10) : c),
                Object.assign(t, { previousSnapIndex: l, snapIndex: o, previousRealIndex: n, realIndex: p, previousIndex: a, activeIndex: c }),
                t.initialized && G(t),
                t.emit("activeIndexChange"),
                t.emit("snapIndexChange"),
                n !== p && t.emit("realIndexChange"),
                (t.initialized || t.params.runCallbacksOnInit) && t.emit("slideChange");
        },
        updateClickedSlide: function (e) {
            const t = this,
                s = t.params,
                i = e.closest(`.${s.slideClass}, swiper-slide`);
            let r,
                a = !1;
            if (i)
                for (let e = 0; e < t.slides.length; e += 1)
                    if (t.slides[e] === i) {
                        (a = !0), (r = e);
                        break;
                    }
            if (!i || !a) return (t.clickedSlide = void 0), void (t.clickedIndex = void 0);
            (t.clickedSlide = i),
                t.virtual && t.params.virtual.enabled ? (t.clickedIndex = parseInt(i.getAttribute("data-swiper-slide-index"), 10)) : (t.clickedIndex = r),
                s.slideToClickedSlide && void 0 !== t.clickedIndex && t.clickedIndex !== t.activeIndex && t.slideToClickedSlide();
        },
    };
    const I = {
        getTranslate: function (e = this.isHorizontal() ? "x" : "y") {
            const { params: t, rtlTranslate: s, translate: i, wrapperEl: r } = this;
            if (t.virtualTranslate) return s ? -i : i;
            if (t.cssMode) return i;
            let a = h(r, e);
            return (a += this.cssOverflowAdjustment()), s && (a = -a), a || 0;
        },
        setTranslate: function (e, t) {
            const s = this,
                { rtlTranslate: i, params: r, wrapperEl: a, progress: n } = s;
            let l,
                o = 0,
                c = 0;
            s.isHorizontal() ? (o = i ? -e : e) : (c = e),
                r.roundLengths && ((o = Math.floor(o)), (c = Math.floor(c))),
                (s.previousTranslate = s.translate),
                (s.translate = s.isHorizontal() ? o : c),
                r.cssMode
                    ? (a[s.isHorizontal() ? "scrollLeft" : "scrollTop"] = s.isHorizontal() ? -o : -c)
                    : r.virtualTranslate || (s.isHorizontal() ? (o -= s.cssOverflowAdjustment()) : (c -= s.cssOverflowAdjustment()), (a.style.transform = `translate3d(${o}px, ${c}px, 0px)`));
            const d = s.maxTranslate() - s.minTranslate();
            (l = 0 === d ? 0 : (e - s.minTranslate()) / d), l !== n && s.updateProgress(e), s.emit("setTranslate", s.translate, t);
        },
        minTranslate: function () {
            return -this.snapGrid[0];
        },
        maxTranslate: function () {
            return -this.snapGrid[this.snapGrid.length - 1];
        },
        translateTo: function (e = 0, t = this.params.speed, s = !0, i = !0, r) {
            const a = this,
                { params: n, wrapperEl: l } = a;
            if (a.animating && n.preventInteractionOnTransition) return !1;
            const o = a.minTranslate(),
                c = a.maxTranslate();
            let d;
            if (((d = i && e > o ? o : i && e < c ? c : e), a.updateProgress(d), n.cssMode)) {
                const e = a.isHorizontal();
                if (0 === t) l[e ? "scrollLeft" : "scrollTop"] = -d;
                else {
                    if (!a.support.smoothScroll) return b({ swiper: a, targetPosition: -d, side: e ? "left" : "top" }), !0;
                    l.scrollTo({ [e ? "left" : "top"]: -d, behavior: "smooth" });
                }
                return !0;
            }
            return (
                0 === t
                    ? (a.setTransition(0), a.setTranslate(d), s && (a.emit("beforeTransitionStart", t, r), a.emit("transitionEnd")))
                    : (a.setTransition(t),
                      a.setTranslate(d),
                      s && (a.emit("beforeTransitionStart", t, r), a.emit("transitionStart")),
                      a.animating ||
                          ((a.animating = !0),
                          a.onTranslateToWrapperTransitionEnd ||
                              (a.onTranslateToWrapperTransitionEnd = function (e) {
                                  a &&
                                      !a.destroyed &&
                                      e.target === this &&
                                      (a.wrapperEl.removeEventListener("transitionend", a.onTranslateToWrapperTransitionEnd),
                                      (a.onTranslateToWrapperTransitionEnd = null),
                                      delete a.onTranslateToWrapperTransitionEnd,
                                      s && a.emit("transitionEnd"));
                              }),
                          a.wrapperEl.addEventListener("transitionend", a.onTranslateToWrapperTransitionEnd))),
                !0
            );
        },
    };
    function $({ swiper: e, runCallbacks: t, direction: s, step: i }) {
        const { activeIndex: r, previousIndex: a } = e;
        let n = s;
        if ((n || (n = r > a ? "next" : r < a ? "prev" : "reset"), e.emit(`transition${i}`), t && r !== a)) {
            if ("reset" === n) return void e.emit(`slideResetTransition${i}`);
            e.emit(`slideChangeTransition${i}`), "next" === n ? e.emit(`slideNextTransition${i}`) : e.emit(`slidePrevTransition${i}`);
        }
    }
    const j = {
        slideTo: function (e = 0, t = this.params.speed, s = !0, i, r) {
            "string" == typeof e && (e = parseInt(e, 10));
            const a = this;
            let n = e;
            n < 0 && (n = 0);
            const { params: l, snapGrid: o, slidesGrid: c, previousIndex: d, activeIndex: p, rtlTranslate: u, wrapperEl: h, enabled: m } = a;
            if ((a.animating && l.preventInteractionOnTransition) || (!m && !i && !r)) return !1;
            const g = Math.min(a.params.slidesPerGroupSkip, n);
            let f = g + Math.floor((n - g) / a.params.slidesPerGroup);
            f >= o.length && (f = o.length - 1);
            const v = -o[f];
            if (l.normalizeSlideIndex)
                for (let e = 0; e < c.length; e += 1) {
                    const t = -Math.floor(100 * v),
                        s = Math.floor(100 * c[e]),
                        i = Math.floor(100 * c[e + 1]);
                    void 0 !== c[e + 1] ? (t >= s && t < i - (i - s) / 2 ? (n = e) : t >= s && t < i && (n = e + 1)) : t >= s && (n = e);
                }
            if (a.initialized && n !== p) {
                if (!a.allowSlideNext && (u ? v > a.translate && v > a.minTranslate() : v < a.translate && v < a.minTranslate())) return !1;
                if (!a.allowSlidePrev && v > a.translate && v > a.maxTranslate() && (p || 0) !== n) return !1;
            }
            let w;
            if ((n !== (d || 0) && s && a.emit("beforeSlideChangeStart"), a.updateProgress(v), (w = n > p ? "next" : n < p ? "prev" : "reset"), (u && -v === a.translate) || (!u && v === a.translate)))
                return a.updateActiveIndex(n), l.autoHeight && a.updateAutoHeight(), a.updateSlidesClasses(), "slide" !== l.effect && a.setTranslate(v), "reset" !== w && (a.transitionStart(s, w), a.transitionEnd(s, w)), !1;
            if (l.cssMode) {
                const e = a.isHorizontal(),
                    s = u ? v : -v;
                if (0 === t) {
                    const t = a.virtual && a.params.virtual.enabled;
                    t && ((a.wrapperEl.style.scrollSnapType = "none"), (a._immediateVirtual = !0)),
                        t && !a._cssModeVirtualInitialSet && a.params.initialSlide > 0
                            ? ((a._cssModeVirtualInitialSet = !0),
                              requestAnimationFrame(() => {
                                  h[e ? "scrollLeft" : "scrollTop"] = s;
                              }))
                            : (h[e ? "scrollLeft" : "scrollTop"] = s),
                        t &&
                            requestAnimationFrame(() => {
                                (a.wrapperEl.style.scrollSnapType = ""), (a._immediateVirtual = !1);
                            });
                } else {
                    if (!a.support.smoothScroll) return b({ swiper: a, targetPosition: s, side: e ? "left" : "top" }), !0;
                    h.scrollTo({ [e ? "left" : "top"]: s, behavior: "smooth" });
                }
                return !0;
            }
            return (
                a.setTransition(t),
                a.setTranslate(v),
                a.updateActiveIndex(n),
                a.updateSlidesClasses(),
                a.emit("beforeTransitionStart", t, i),
                a.transitionStart(s, w),
                0 === t
                    ? a.transitionEnd(s, w)
                    : a.animating ||
                      ((a.animating = !0),
                      a.onSlideToWrapperTransitionEnd ||
                          (a.onSlideToWrapperTransitionEnd = function (e) {
                              a &&
                                  !a.destroyed &&
                                  e.target === this &&
                                  (a.wrapperEl.removeEventListener("transitionend", a.onSlideToWrapperTransitionEnd), (a.onSlideToWrapperTransitionEnd = null), delete a.onSlideToWrapperTransitionEnd, a.transitionEnd(s, w));
                          }),
                      a.wrapperEl.addEventListener("transitionend", a.onSlideToWrapperTransitionEnd)),
                !0
            );
        },
        slideToLoop: function (e = 0, t = this.params.speed, s = !0, i) {
            if ("string" == typeof e) {
                e = parseInt(e, 10);
            }
            const r = this;
            let a = e;
            return r.params.loop && (r.virtual && r.params.virtual.enabled ? (a += r.virtual.slidesBefore) : (a = r.getSlideIndexByData(a))), r.slideTo(a, t, s, i);
        },
        slideNext: function (e = this.params.speed, t = !0, s) {
            const i = this,
                { enabled: r, params: a, animating: n } = i;
            if (!r) return i;
            let l = a.slidesPerGroup;
            "auto" === a.slidesPerView && 1 === a.slidesPerGroup && a.slidesPerGroupAuto && (l = Math.max(i.slidesPerViewDynamic("current", !0), 1));
            const o = i.activeIndex < a.slidesPerGroupSkip ? 1 : l,
                c = i.virtual && a.virtual.enabled;
            if (a.loop) {
                if (n && !c && a.loopPreventsSliding) return !1;
                i.loopFix({ direction: "next" }), (i._clientLeft = i.wrapperEl.clientLeft);
            }
            return a.rewind && i.isEnd ? i.slideTo(0, e, t, s) : i.slideTo(i.activeIndex + o, e, t, s);
        },
        slidePrev: function (e = this.params.speed, t = !0, s) {
            const i = this,
                { params: r, snapGrid: a, slidesGrid: n, rtlTranslate: l, enabled: o, animating: c } = i;
            if (!o) return i;
            const d = i.virtual && r.virtual.enabled;
            if (r.loop) {
                if (c && !d && r.loopPreventsSliding) return !1;
                i.loopFix({ direction: "prev" }), (i._clientLeft = i.wrapperEl.clientLeft);
            }
            function p(e) {
                return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
            }
            const u = p(l ? i.translate : -i.translate),
                h = a.map((e) => p(e));
            let m = a[h.indexOf(u) - 1];
            if (void 0 === m && r.cssMode) {
                let e;
                a.forEach((t, s) => {
                    u >= t && (e = s);
                }),
                    void 0 !== e && (m = a[e > 0 ? e - 1 : e]);
            }
            let g = 0;
            if (
                (void 0 !== m &&
                    ((g = n.indexOf(m)), g < 0 && (g = i.activeIndex - 1), "auto" === r.slidesPerView && 1 === r.slidesPerGroup && r.slidesPerGroupAuto && ((g = g - i.slidesPerViewDynamic("previous", !0) + 1), (g = Math.max(g, 0)))),
                r.rewind && i.isBeginning)
            ) {
                const r = i.params.virtual && i.params.virtual.enabled && i.virtual ? i.virtual.slides.length - 1 : i.slides.length - 1;
                return i.slideTo(r, e, t, s);
            }
            return i.slideTo(g, e, t, s);
        },
        slideReset: function (e = this.params.speed, t = !0, s) {
            return this.slideTo(this.activeIndex, e, t, s);
        },
        slideToClosest: function (e = this.params.speed, t = !0, s, i = 0.5) {
            const r = this;
            let a = r.activeIndex;
            const n = Math.min(r.params.slidesPerGroupSkip, a),
                l = n + Math.floor((a - n) / r.params.slidesPerGroup),
                o = r.rtlTranslate ? r.translate : -r.translate;
            if (o >= r.snapGrid[l]) {
                const e = r.snapGrid[l];
                o - e > (r.snapGrid[l + 1] - e) * i && (a += r.params.slidesPerGroup);
            } else {
                const e = r.snapGrid[l - 1];
                o - e <= (r.snapGrid[l] - e) * i && (a -= r.params.slidesPerGroup);
            }
            return (a = Math.max(a, 0)), (a = Math.min(a, r.slidesGrid.length - 1)), r.slideTo(a, e, t, s);
        },
        slideToClickedSlide: function () {
            const e = this,
                { params: t, slidesEl: s } = e,
                i = "auto" === t.slidesPerView ? e.slidesPerViewDynamic() : t.slidesPerView;
            let r,
                a = e.clickedIndex;
            const n = e.isElement ? "swiper-slide" : `.${t.slideClass}`;
            if (t.loop) {
                if (e.animating) return;
                (r = parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10)),
                    t.centeredSlides
                        ? a < e.loopedSlides - i / 2 || a > e.slides.length - e.loopedSlides + i / 2
                            ? (e.loopFix(),
                              (a = e.getSlideIndex(v(s, `${n}[data-swiper-slide-index="${r}"]`)[0])),
                              p(() => {
                                  e.slideTo(a);
                              }))
                            : e.slideTo(a)
                        : a > e.slides.length - i
                        ? (e.loopFix(),
                          (a = e.getSlideIndex(v(s, `${n}[data-swiper-slide-index="${r}"]`)[0])),
                          p(() => {
                              e.slideTo(a);
                          }))
                        : e.slideTo(a);
            } else e.slideTo(a);
        },
    };
    const D = {
        loopCreate: function (e) {
            const t = this,
                { params: s, slidesEl: i } = t;
            if (!s.loop || (t.virtual && t.params.virtual.enabled)) return;
            v(i, `.${s.slideClass}, swiper-slide`).forEach((e, t) => {
                e.setAttribute("data-swiper-slide-index", t);
            }),
                t.loopFix({ slideRealIndex: e, direction: s.centeredSlides ? void 0 : "next" });
        },
        loopFix: function ({ slideRealIndex: e, slideTo: t = !0, direction: s, setTranslate: i, activeSlideIndex: r, byController: a, byMousewheel: n } = {}) {
            const l = this;
            if (!l.params.loop) return;
            l.emit("beforeLoopFix");
            const { slides: o, allowSlidePrev: c, allowSlideNext: d, slidesEl: p, params: u } = l;
            if (((l.allowSlidePrev = !0), (l.allowSlideNext = !0), l.virtual && u.virtual.enabled))
                return (
                    t &&
                        (u.centeredSlides || 0 !== l.snapIndex
                            ? u.centeredSlides && l.snapIndex < u.slidesPerView
                                ? l.slideTo(l.virtual.slides.length + l.snapIndex, 0, !1, !0)
                                : l.snapIndex === l.snapGrid.length - 1 && l.slideTo(l.virtual.slidesBefore, 0, !1, !0)
                            : l.slideTo(l.virtual.slides.length, 0, !1, !0)),
                    (l.allowSlidePrev = c),
                    (l.allowSlideNext = d),
                    void l.emit("loopFix")
                );
            const h = "auto" === u.slidesPerView ? l.slidesPerViewDynamic() : Math.ceil(parseFloat(u.slidesPerView, 10));
            let m = u.loopedSlides || h;
            m % u.slidesPerGroup != 0 && (m += u.slidesPerGroup - (m % u.slidesPerGroup)), (l.loopedSlides = m);
            const g = [],
                f = [];
            let b = l.activeIndex;
            void 0 === r ? (r = l.getSlideIndex(l.slides.filter((e) => e.classList.contains(u.slideActiveClass))[0])) : (b = r);
            const v = "next" === s || !s,
                w = "prev" === s || !s;
            let y = 0,
                S = 0;
            if (r < m) {
                y = Math.max(m - r, u.slidesPerGroup);
                for (let e = 0; e < m - r; e += 1) {
                    const t = e - Math.floor(e / o.length) * o.length;
                    g.push(o.length - t - 1);
                }
            } else if (r > l.slides.length - 2 * m) {
                S = Math.max(r - (l.slides.length - 2 * m), u.slidesPerGroup);
                for (let e = 0; e < S; e += 1) {
                    const t = e - Math.floor(e / o.length) * o.length;
                    f.push(t);
                }
            }
            if (
                (w &&
                    g.forEach((e) => {
                        (l.slides[e].swiperLoopMoveDOM = !0), p.prepend(l.slides[e]), (l.slides[e].swiperLoopMoveDOM = !1);
                    }),
                v &&
                    f.forEach((e) => {
                        (l.slides[e].swiperLoopMoveDOM = !0), p.append(l.slides[e]), (l.slides[e].swiperLoopMoveDOM = !1);
                    }),
                l.recalcSlides(),
                "auto" === u.slidesPerView && l.updateSlides(),
                u.watchSlidesProgress && l.updateSlidesOffset(),
                t)
            )
                if (g.length > 0 && w)
                    if (void 0 === e) {
                        const e = l.slidesGrid[b],
                            t = l.slidesGrid[b + y] - e;
                        n ? l.setTranslate(l.translate - t) : (l.slideTo(b + y, 0, !1, !0), i && (l.touches[l.isHorizontal() ? "startX" : "startY"] += t));
                    } else i && l.slideToLoop(e, 0, !1, !0);
                else if (f.length > 0 && v)
                    if (void 0 === e) {
                        const e = l.slidesGrid[b],
                            t = l.slidesGrid[b - S] - e;
                        n ? l.setTranslate(l.translate - t) : (l.slideTo(b - S, 0, !1, !0), i && (l.touches[l.isHorizontal() ? "startX" : "startY"] += t));
                    } else l.slideToLoop(e, 0, !1, !0);
            if (((l.allowSlidePrev = c), (l.allowSlideNext = d), l.controller && l.controller.control && !a)) {
                const t = { slideRealIndex: e, slideTo: !1, direction: s, setTranslate: i, activeSlideIndex: r, byController: !0 };
                Array.isArray(l.controller.control)
                    ? l.controller.control.forEach((e) => {
                          !e.destroyed && e.params.loop && e.loopFix(t);
                      })
                    : l.controller.control instanceof l.constructor && l.controller.control.params.loop && l.controller.control.loopFix(t);
            }
            l.emit("loopFix");
        },
        loopDestroy: function () {
            const e = this,
                { params: t, slidesEl: s } = e;
            if (!t.loop || (e.virtual && e.params.virtual.enabled)) return;
            e.recalcSlides();
            const i = [];
            e.slides.forEach((e) => {
                const t = void 0 === e.swiperSlideIndex ? 1 * e.getAttribute("data-swiper-slide-index") : e.swiperSlideIndex;
                i[t] = e;
            }),
                e.slides.forEach((e) => {
                    e.removeAttribute("data-swiper-slide-index");
                }),
                i.forEach((e) => {
                    s.append(e);
                }),
                e.recalcSlides(),
                e.slideTo(e.realIndex, 0);
        },
    };
    function B(e) {
        const t = this,
            s = o(),
            i = d(),
            r = t.touchEventsData;
        r.evCache.push(e);
        const { params: a, touches: n, enabled: l } = t;
        if (!l) return;
        if (!a.simulateTouch && "mouse" === e.pointerType) return;
        if (t.animating && a.preventInteractionOnTransition) return;
        !t.animating && a.cssMode && a.loop && t.loopFix();
        let c = e;
        c.originalEvent && (c = c.originalEvent);
        let p = c.target;
        if ("wrapper" === a.touchEventsTarget && !t.wrapperEl.contains(p)) return;
        if ("which" in c && 3 === c.which) return;
        if ("button" in c && c.button > 0) return;
        if (r.isTouched && r.isMoved) return;
        const h = !!a.noSwipingClass && "" !== a.noSwipingClass,
            m = e.composedPath ? e.composedPath() : e.path;
        h && c.target && c.target.shadowRoot && m && (p = m[0]);
        const g = a.noSwipingSelector ? a.noSwipingSelector : `.${a.noSwipingClass}`,
            f = !(!c.target || !c.target.shadowRoot);
        if (
            a.noSwiping &&
            (f
                ? (function (e, t = this) {
                      return (function t(s) {
                          if (!s || s === o() || s === d()) return null;
                          s.assignedSlot && (s = s.assignedSlot);
                          const i = s.closest(e);
                          return i || s.getRootNode ? i || t(s.getRootNode().host) : null;
                      })(t);
                  })(g, p)
                : p.closest(g))
        )
            return void (t.allowClick = !0);
        if (a.swipeHandler && !p.closest(a.swipeHandler)) return;
        (n.currentX = c.pageX), (n.currentY = c.pageY);
        const b = n.currentX,
            v = n.currentY,
            w = a.edgeSwipeDetection || a.iOSEdgeSwipeDetection,
            y = a.edgeSwipeThreshold || a.iOSEdgeSwipeThreshold;
        if (w && (b <= y || b >= i.innerWidth - y)) {
            if ("prevent" !== w) return;
            e.preventDefault();
        }
        Object.assign(r, { isTouched: !0, isMoved: !1, allowTouchCallbacks: !0, isScrolling: void 0, startMoving: void 0 }),
            (n.startX = b),
            (n.startY = v),
            (r.touchStartTime = u()),
            (t.allowClick = !0),
            t.updateSize(),
            (t.swipeDirection = void 0),
            a.threshold > 0 && (r.allowThresholdMove = !1);
        let S = !0;
        p.matches(r.focusableElements) && ((S = !1), "SELECT" === p.nodeName && (r.isTouched = !1)), s.activeElement && s.activeElement.matches(r.focusableElements) && s.activeElement !== p && s.activeElement.blur();
        const A = S && t.allowTouchMove && a.touchStartPreventDefault;
        (!a.touchStartForcePreventDefault && !A) || p.isContentEditable || c.preventDefault(), a.freeMode && a.freeMode.enabled && t.freeMode && t.animating && !a.cssMode && t.freeMode.onTouchStart(), t.emit("touchStart", c);
    }
    function H(e) {
        const t = o(),
            s = this,
            i = s.touchEventsData,
            { params: r, touches: a, rtlTranslate: n, enabled: l } = s;
        if (!l) return;
        if (!r.simulateTouch && "mouse" === e.pointerType) return;
        let c = e;
        if ((c.originalEvent && (c = c.originalEvent), !i.isTouched)) return void (i.startMoving && i.isScrolling && s.emit("touchMoveOpposite", c));
        const d = i.evCache.findIndex((e) => e.pointerId === c.pointerId);
        d >= 0 && (i.evCache[d] = c);
        const p = i.evCache.length > 1 ? i.evCache[0] : c,
            h = p.pageX,
            m = p.pageY;
        if (c.preventedByNestedSwiper) return (a.startX = h), void (a.startY = m);
        if (!s.allowTouchMove)
            return (
                c.target.matches(i.focusableElements) || (s.allowClick = !1),
                void (i.isTouched && (Object.assign(a, { startX: h, startY: m, prevX: s.touches.currentX, prevY: s.touches.currentY, currentX: h, currentY: m }), (i.touchStartTime = u())))
            );
        if (r.touchReleaseOnEdges && !r.loop)
            if (s.isVertical()) {
                if ((m < a.startY && s.translate <= s.maxTranslate()) || (m > a.startY && s.translate >= s.minTranslate())) return (i.isTouched = !1), void (i.isMoved = !1);
            } else if ((h < a.startX && s.translate <= s.maxTranslate()) || (h > a.startX && s.translate >= s.minTranslate())) return;
        if (t.activeElement && c.target === t.activeElement && c.target.matches(i.focusableElements)) return (i.isMoved = !0), void (s.allowClick = !1);
        if ((i.allowTouchCallbacks && s.emit("touchMove", c), c.targetTouches && c.targetTouches.length > 1)) return;
        (a.currentX = h), (a.currentY = m);
        const g = a.currentX - a.startX,
            f = a.currentY - a.startY;
        if (s.params.threshold && Math.sqrt(g ** 2 + f ** 2) < s.params.threshold) return;
        if (void 0 === i.isScrolling) {
            let e;
            (s.isHorizontal() && a.currentY === a.startY) || (s.isVertical() && a.currentX === a.startX)
                ? (i.isScrolling = !1)
                : g * g + f * f >= 25 && ((e = (180 * Math.atan2(Math.abs(f), Math.abs(g))) / Math.PI), (i.isScrolling = s.isHorizontal() ? e > r.touchAngle : 90 - e > r.touchAngle));
        }
        if (
            (i.isScrolling && s.emit("touchMoveOpposite", c),
            void 0 === i.startMoving && ((a.currentX === a.startX && a.currentY === a.startY) || (i.startMoving = !0)),
            i.isScrolling || (s.zoom && s.params.zoom && s.params.zoom.enabled && i.evCache.length > 1))
        )
            return void (i.isTouched = !1);
        if (!i.startMoving) return;
        (s.allowClick = !1), !r.cssMode && c.cancelable && c.preventDefault(), r.touchMoveStopPropagation && !r.nested && c.stopPropagation();
        let b = s.isHorizontal() ? g : f,
            v = s.isHorizontal() ? a.currentX - a.previousX : a.currentY - a.previousY;
        r.oneWayMovement && ((b = Math.abs(b) * (n ? 1 : -1)), (v = Math.abs(v) * (n ? 1 : -1))), (a.diff = b), (b *= r.touchRatio), n && ((b = -b), (v = -v));
        const w = s.touchesDirection;
        (s.swipeDirection = b > 0 ? "prev" : "next"), (s.touchesDirection = v > 0 ? "prev" : "next");
        const y = s.params.loop && !r.cssMode;
        if (!i.isMoved) {
            if ((y && s.loopFix({ direction: s.swipeDirection }), (i.startTranslate = s.getTranslate()), s.setTransition(0), s.animating)) {
                const e = new window.CustomEvent("transitionend", { bubbles: !0, cancelable: !0 });
                s.wrapperEl.dispatchEvent(e);
            }
            (i.allowMomentumBounce = !1), !r.grabCursor || (!0 !== s.allowSlideNext && !0 !== s.allowSlidePrev) || s.setGrabCursor(!0), s.emit("sliderFirstMove", c);
        }
        let S;
        i.isMoved && w !== s.touchesDirection && y && Math.abs(b) >= 1 && (s.loopFix({ direction: s.swipeDirection, setTranslate: !0 }), (S = !0)), s.emit("sliderMove", c), (i.isMoved = !0), (i.currentTranslate = b + i.startTranslate);
        let A = !0,
            E = r.resistanceRatio;
        if (
            (r.touchReleaseOnEdges && (E = 0),
            b > 0
                ? (y && !S && i.currentTranslate > (r.centeredSlides ? s.minTranslate() - s.size / 2 : s.minTranslate()) && s.loopFix({ direction: "prev", setTranslate: !0, activeSlideIndex: 0 }),
                  i.currentTranslate > s.minTranslate() && ((A = !1), r.resistance && (i.currentTranslate = s.minTranslate() - 1 + (-s.minTranslate() + i.startTranslate + b) ** E)))
                : b < 0 &&
                  (y &&
                      !S &&
                      i.currentTranslate < (r.centeredSlides ? s.maxTranslate() + s.size / 2 : s.maxTranslate()) &&
                      s.loopFix({ direction: "next", setTranslate: !0, activeSlideIndex: s.slides.length - ("auto" === r.slidesPerView ? s.slidesPerViewDynamic() : Math.ceil(parseFloat(r.slidesPerView, 10))) }),
                  i.currentTranslate < s.maxTranslate() && ((A = !1), r.resistance && (i.currentTranslate = s.maxTranslate() + 1 - (s.maxTranslate() - i.startTranslate - b) ** E))),
            A && (c.preventedByNestedSwiper = !0),
            !s.allowSlideNext && "next" === s.swipeDirection && i.currentTranslate < i.startTranslate && (i.currentTranslate = i.startTranslate),
            !s.allowSlidePrev && "prev" === s.swipeDirection && i.currentTranslate > i.startTranslate && (i.currentTranslate = i.startTranslate),
            s.allowSlidePrev || s.allowSlideNext || (i.currentTranslate = i.startTranslate),
            r.threshold > 0)
        ) {
            if (!(Math.abs(b) > r.threshold || i.allowThresholdMove)) return void (i.currentTranslate = i.startTranslate);
            if (!i.allowThresholdMove)
                return (i.allowThresholdMove = !0), (a.startX = a.currentX), (a.startY = a.currentY), (i.currentTranslate = i.startTranslate), void (a.diff = s.isHorizontal() ? a.currentX - a.startX : a.currentY - a.startY);
        }
        r.followFinger &&
            !r.cssMode &&
            (((r.freeMode && r.freeMode.enabled && s.freeMode) || r.watchSlidesProgress) && (s.updateActiveIndex(), s.updateSlidesClasses()),
            r.freeMode && r.freeMode.enabled && s.freeMode && s.freeMode.onTouchMove(),
            s.updateProgress(i.currentTranslate),
            s.setTranslate(i.currentTranslate));
    }
    function q(e) {
        const t = this,
            s = t.touchEventsData,
            i = s.evCache.findIndex((t) => t.pointerId === e.pointerId);
        if ((i >= 0 && s.evCache.splice(i, 1), ["pointercancel", "pointerout", "pointerleave"].includes(e.type))) {
            if (!("pointercancel" === e.type && (t.browser.isSafari || t.browser.isWebView))) return;
        }
        const { params: r, touches: a, rtlTranslate: n, slidesGrid: l, enabled: o } = t;
        if (!o) return;
        if (!r.simulateTouch && "mouse" === e.pointerType) return;
        let c = e;
        if ((c.originalEvent && (c = c.originalEvent), s.allowTouchCallbacks && t.emit("touchEnd", c), (s.allowTouchCallbacks = !1), !s.isTouched))
            return s.isMoved && r.grabCursor && t.setGrabCursor(!1), (s.isMoved = !1), void (s.startMoving = !1);
        r.grabCursor && s.isMoved && s.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1);
        const d = u(),
            h = d - s.touchStartTime;
        if (t.allowClick) {
            const e = c.path || (c.composedPath && c.composedPath());
            t.updateClickedSlide((e && e[0]) || c.target), t.emit("tap click", c), h < 300 && d - s.lastClickTime < 300 && t.emit("doubleTap doubleClick", c);
        }
        if (
            ((s.lastClickTime = u()),
            p(() => {
                t.destroyed || (t.allowClick = !0);
            }),
            !s.isTouched || !s.isMoved || !t.swipeDirection || 0 === a.diff || s.currentTranslate === s.startTranslate)
        )
            return (s.isTouched = !1), (s.isMoved = !1), void (s.startMoving = !1);
        let m;
        if (((s.isTouched = !1), (s.isMoved = !1), (s.startMoving = !1), (m = r.followFinger ? (n ? t.translate : -t.translate) : -s.currentTranslate), r.cssMode)) return;
        if (r.freeMode && r.freeMode.enabled) return void t.freeMode.onTouchEnd({ currentPos: m });
        let g = 0,
            f = t.slidesSizesGrid[0];
        for (let e = 0; e < l.length; e += e < r.slidesPerGroupSkip ? 1 : r.slidesPerGroup) {
            const t = e < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
            void 0 !== l[e + t] ? m >= l[e] && m < l[e + t] && ((g = e), (f = l[e + t] - l[e])) : m >= l[e] && ((g = e), (f = l[l.length - 1] - l[l.length - 2]));
        }
        let b = null,
            v = null;
        r.rewind && (t.isBeginning ? (v = r.virtual && r.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1) : t.isEnd && (b = 0));
        const w = (m - l[g]) / f,
            y = g < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
        if (h > r.longSwipesMs) {
            if (!r.longSwipes) return void t.slideTo(t.activeIndex);
            "next" === t.swipeDirection && (w >= r.longSwipesRatio ? t.slideTo(r.rewind && t.isEnd ? b : g + y) : t.slideTo(g)),
                "prev" === t.swipeDirection && (w > 1 - r.longSwipesRatio ? t.slideTo(g + y) : null !== v && w < 0 && Math.abs(w) > r.longSwipesRatio ? t.slideTo(v) : t.slideTo(g));
        } else {
            if (!r.shortSwipes) return void t.slideTo(t.activeIndex);
            t.navigation && (c.target === t.navigation.nextEl || c.target === t.navigation.prevEl)
                ? c.target === t.navigation.nextEl
                    ? t.slideTo(g + y)
                    : t.slideTo(g)
                : ("next" === t.swipeDirection && t.slideTo(null !== b ? b : g + y), "prev" === t.swipeDirection && t.slideTo(null !== v ? v : g));
        }
    }
    function N() {
        const e = this,
            { params: t, el: s } = e;
        if (s && 0 === s.offsetWidth) return;
        t.breakpoints && e.setBreakpoint();
        const { allowSlideNext: i, allowSlidePrev: r, snapGrid: a } = e,
            n = e.virtual && e.params.virtual.enabled;
        (e.allowSlideNext = !0), (e.allowSlidePrev = !0), e.updateSize(), e.updateSlides(), e.updateSlidesClasses();
        const l = n && t.loop;
        !("auto" === t.slidesPerView || t.slidesPerView > 1) || !e.isEnd || e.isBeginning || e.params.centeredSlides || l
            ? e.params.loop && !n
                ? e.slideToLoop(e.realIndex, 0, !1, !0)
                : e.slideTo(e.activeIndex, 0, !1, !0)
            : e.slideTo(e.slides.length - 1, 0, !1, !0),
            e.autoplay &&
                e.autoplay.running &&
                e.autoplay.paused &&
                (clearTimeout(e.autoplay.resizeTimeout),
                (e.autoplay.resizeTimeout = setTimeout(() => {
                    e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume();
                }, 500))),
            (e.allowSlidePrev = r),
            (e.allowSlideNext = i),
            e.params.watchOverflow && a !== e.snapGrid && e.checkOverflow();
    }
    function F(e) {
        const t = this;
        t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
    }
    function V() {
        const e = this,
            { wrapperEl: t, rtlTranslate: s, enabled: i } = e;
        if (!i) return;
        let r;
        (e.previousTranslate = e.translate), e.isHorizontal() ? (e.translate = -t.scrollLeft) : (e.translate = -t.scrollTop), 0 === e.translate && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
        const a = e.maxTranslate() - e.minTranslate();
        (r = 0 === a ? 0 : (e.translate - e.minTranslate()) / a), r !== e.progress && e.updateProgress(s ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
    }
    function Y(e) {
        const t = this;
        P(t, e.target), t.params.cssMode || ("auto" !== t.params.slidesPerView && !t.params.autoHeight) || t.update();
    }
    let R = !1;
    function W() {}
    const U = (e, t) => {
        const s = o(),
            { params: i, el: r, wrapperEl: a, device: n } = e,
            l = !!i.nested,
            c = "on" === t ? "addEventListener" : "removeEventListener",
            d = t;
        r[c]("pointerdown", e.onTouchStart, { passive: !1 }),
            s[c]("pointermove", e.onTouchMove, { passive: !1, capture: l }),
            s[c]("pointerup", e.onTouchEnd, { passive: !0 }),
            s[c]("pointercancel", e.onTouchEnd, { passive: !0 }),
            s[c]("pointerout", e.onTouchEnd, { passive: !0 }),
            s[c]("pointerleave", e.onTouchEnd, { passive: !0 }),
            (i.preventClicks || i.preventClicksPropagation) && r[c]("click", e.onClick, !0),
            i.cssMode && a[c]("scroll", e.onScroll),
            i.updateOnWindowResize ? e[d](n.ios || n.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", N, !0) : e[d]("observerUpdate", N, !0),
            r[c]("load", e.onLoad, { capture: !0 });
    };
    const X = (e, t) => e.grid && t.grid && t.grid.rows > 1;
    const Q = {
        setBreakpoint: function () {
            const e = this,
                { realIndex: t, initialized: s, params: i, el: r } = e,
                a = i.breakpoints;
            if (!a || (a && 0 === Object.keys(a).length)) return;
            const n = e.getBreakpoint(a, e.params.breakpointsBase, e.el);
            if (!n || e.currentBreakpoint === n) return;
            const l = (n in a ? a[n] : void 0) || e.originalParams,
                o = X(e, i),
                c = X(e, l),
                d = i.enabled;
            o && !c
                ? (r.classList.remove(`${i.containerModifierClass}grid`, `${i.containerModifierClass}grid-column`), e.emitContainerClasses())
                : !o &&
                  c &&
                  (r.classList.add(`${i.containerModifierClass}grid`),
                  ((l.grid.fill && "column" === l.grid.fill) || (!l.grid.fill && "column" === i.grid.fill)) && r.classList.add(`${i.containerModifierClass}grid-column`),
                  e.emitContainerClasses()),
                ["navigation", "pagination", "scrollbar"].forEach((t) => {
                    if (void 0 === l[t]) return;
                    const s = i[t] && i[t].enabled,
                        r = l[t] && l[t].enabled;
                    s && !r && e[t].disable(), !s && r && e[t].enable();
                });
            const p = l.direction && l.direction !== i.direction,
                u = i.loop && (l.slidesPerView !== i.slidesPerView || p);
            p && s && e.changeDirection(), g(e.params, l);
            const h = e.params.enabled;
            Object.assign(e, { allowTouchMove: e.params.allowTouchMove, allowSlideNext: e.params.allowSlideNext, allowSlidePrev: e.params.allowSlidePrev }),
                d && !h ? e.disable() : !d && h && e.enable(),
                (e.currentBreakpoint = n),
                e.emit("_beforeBreakpoint", l),
                u && s && (e.loopDestroy(), e.loopCreate(t), e.updateSlides()),
                e.emit("breakpoint", l);
        },
        getBreakpoint: function (e, t = "window", s) {
            if (!e || ("container" === t && !s)) return;
            let i = !1;
            const r = d(),
                a = "window" === t ? r.innerHeight : s.clientHeight,
                n = Object.keys(e).map((e) => {
                    if ("string" == typeof e && 0 === e.indexOf("@")) {
                        const t = parseFloat(e.substr(1));
                        return { value: a * t, point: e };
                    }
                    return { value: e, point: e };
                });
            n.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
            for (let e = 0; e < n.length; e += 1) {
                const { point: a, value: l } = n[e];
                "window" === t ? r.matchMedia(`(min-width: ${l}px)`).matches && (i = a) : l <= s.clientWidth && (i = a);
            }
            return i || "max";
        },
    };
    const J = {
        init: !0,
        direction: "horizontal",
        oneWayMovement: !1,
        touchEventsTarget: "wrapper",
        initialSlide: 0,
        speed: 300,
        cssMode: !1,
        updateOnWindowResize: !0,
        resizeObserver: !0,
        nested: !1,
        createElements: !1,
        enabled: !0,
        focusableElements: "input, select, option, textarea, button, video, label",
        width: null,
        height: null,
        preventInteractionOnTransition: !1,
        userAgent: null,
        url: null,
        edgeSwipeDetection: !1,
        edgeSwipeThreshold: 20,
        autoHeight: !1,
        setWrapperSize: !1,
        virtualTranslate: !1,
        effect: "slide",
        breakpoints: void 0,
        breakpointsBase: "window",
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerGroup: 1,
        slidesPerGroupSkip: 0,
        slidesPerGroupAuto: !1,
        centeredSlides: !1,
        centeredSlidesBounds: !1,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        normalizeSlideIndex: !0,
        centerInsufficientSlides: !1,
        watchOverflow: !0,
        roundLengths: !1,
        touchRatio: 1,
        touchAngle: 45,
        simulateTouch: !0,
        shortSwipes: !0,
        longSwipes: !0,
        longSwipesRatio: 0.5,
        longSwipesMs: 300,
        followFinger: !0,
        allowTouchMove: !0,
        threshold: 5,
        touchMoveStopPropagation: !1,
        touchStartPreventDefault: !0,
        touchStartForcePreventDefault: !1,
        touchReleaseOnEdges: !1,
        uniqueNavElements: !0,
        resistance: !0,
        resistanceRatio: 0.85,
        watchSlidesProgress: !1,
        grabCursor: !1,
        preventClicks: !0,
        preventClicksPropagation: !0,
        slideToClickedSlide: !1,
        loop: !1,
        loopedSlides: null,
        loopPreventsSliding: !0,
        rewind: !1,
        allowSlidePrev: !0,
        allowSlideNext: !0,
        swipeHandler: null,
        noSwiping: !0,
        noSwipingClass: "swiper-no-swiping",
        noSwipingSelector: null,
        passiveListeners: !0,
        maxBackfaceHiddenSlides: 10,
        containerModifierClass: "swiper-",
        slideClass: "swiper-slide",
        slideActiveClass: "swiper-slide-active",
        slideVisibleClass: "swiper-slide-visible",
        slideNextClass: "swiper-slide-next",
        slidePrevClass: "swiper-slide-prev",
        wrapperClass: "swiper-wrapper",
        lazyPreloaderClass: "swiper-lazy-preloader",
        lazyPreloadPrevNext: 0,
        runCallbacksOnInit: !0,
        _emitClasses: !1,
    };
    function Z(e, t) {
        return function (s = {}) {
            const i = Object.keys(s)[0],
                r = s[i];
            "object" == typeof r && null !== r
                ? (["navigation", "pagination", "scrollbar"].indexOf(i) >= 0 && !0 === e[i] && (e[i] = { auto: !0 }),
                  i in e && "enabled" in r ? (!0 === e[i] && (e[i] = { enabled: !0 }), "object" != typeof e[i] || "enabled" in e[i] || (e[i].enabled = !0), e[i] || (e[i] = { enabled: !1 }), g(t, s)) : g(t, s))
                : g(t, s);
        };
    }
    const K = {
            eventsEmitter: O,
            update: z,
            translate: I,
            transition: {
                setTransition: function (e, t) {
                    const s = this;
                    s.params.cssMode || (s.wrapperEl.style.transitionDuration = `${e}ms`), s.emit("setTransition", e, t);
                },
                transitionStart: function (e = !0, t) {
                    const s = this,
                        { params: i } = s;
                    i.cssMode || (i.autoHeight && s.updateAutoHeight(), $({ swiper: s, runCallbacks: e, direction: t, step: "Start" }));
                },
                transitionEnd: function (e = !0, t) {
                    const s = this,
                        { params: i } = s;
                    (s.animating = !1), i.cssMode || (s.setTransition(0), $({ swiper: s, runCallbacks: e, direction: t, step: "End" }));
                },
            },
            slide: j,
            loop: D,
            grabCursor: {
                setGrabCursor: function (e) {
                    const t = this;
                    if (!t.params.simulateTouch || (t.params.watchOverflow && t.isLocked) || t.params.cssMode) return;
                    const s = "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl;
                    t.isElement && (t.__preventObserver__ = !0),
                        (s.style.cursor = "move"),
                        (s.style.cursor = e ? "grabbing" : "grab"),
                        t.isElement &&
                            requestAnimationFrame(() => {
                                t.__preventObserver__ = !1;
                            });
                },
                unsetGrabCursor: function () {
                    const e = this;
                    (e.params.watchOverflow && e.isLocked) ||
                        e.params.cssMode ||
                        (e.isElement && (e.__preventObserver__ = !0),
                        (e["container" === e.params.touchEventsTarget ? "el" : "wrapperEl"].style.cursor = ""),
                        e.isElement &&
                            requestAnimationFrame(() => {
                                e.__preventObserver__ = !1;
                            }));
                },
            },
            events: {
                attachEvents: function () {
                    const e = this,
                        t = o(),
                        { params: s } = e;
                    (e.onTouchStart = B.bind(e)),
                        (e.onTouchMove = H.bind(e)),
                        (e.onTouchEnd = q.bind(e)),
                        s.cssMode && (e.onScroll = V.bind(e)),
                        (e.onClick = F.bind(e)),
                        (e.onLoad = Y.bind(e)),
                        R || (t.addEventListener("touchstart", W), (R = !0)),
                        U(e, "on");
                },
                detachEvents: function () {
                    U(this, "off");
                },
            },
            breakpoints: Q,
            checkOverflow: {
                checkOverflow: function () {
                    const e = this,
                        { isLocked: t, params: s } = e,
                        { slidesOffsetBefore: i } = s;
                    if (i) {
                        const t = e.slides.length - 1,
                            s = e.slidesGrid[t] + e.slidesSizesGrid[t] + 2 * i;
                        e.isLocked = e.size > s;
                    } else e.isLocked = 1 === e.snapGrid.length;
                    !0 === s.allowSlideNext && (e.allowSlideNext = !e.isLocked),
                        !0 === s.allowSlidePrev && (e.allowSlidePrev = !e.isLocked),
                        t && t !== e.isLocked && (e.isEnd = !1),
                        t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
                },
            },
            classes: {
                addClasses: function () {
                    const e = this,
                        { classNames: t, params: s, rtl: i, el: r, device: a } = e,
                        n = (function (e, t) {
                            const s = [];
                            return (
                                e.forEach((e) => {
                                    "object" == typeof e
                                        ? Object.keys(e).forEach((i) => {
                                              e[i] && s.push(t + i);
                                          })
                                        : "string" == typeof e && s.push(t + e);
                                }),
                                s
                            );
                        })(
                            [
                                "initialized",
                                s.direction,
                                { "free-mode": e.params.freeMode && s.freeMode.enabled },
                                { autoheight: s.autoHeight },
                                { rtl: i },
                                { grid: s.grid && s.grid.rows > 1 },
                                { "grid-column": s.grid && s.grid.rows > 1 && "column" === s.grid.fill },
                                { android: a.android },
                                { ios: a.ios },
                                { "css-mode": s.cssMode },
                                { centered: s.cssMode && s.centeredSlides },
                                { "watch-progress": s.watchSlidesProgress },
                            ],
                            s.containerModifierClass
                        );
                    t.push(...n), r.classList.add(...t), e.emitContainerClasses();
                },
                removeClasses: function () {
                    const { el: e, classNames: t } = this;
                    e.classList.remove(...t), this.emitContainerClasses();
                },
            },
        },
        ee = {};
    class Swiper {
        constructor(...e) {
            let t, s;
            1 === e.length && e[0].constructor && "Object" === Object.prototype.toString.call(e[0]).slice(8, -1) ? (s = e[0]) : ([t, s] = e), s || (s = {}), (s = g({}, s)), t && !s.el && (s.el = t);
            const i = o();
            if (s.el && "string" == typeof s.el && i.querySelectorAll(s.el).length > 1) {
                const e = [];
                return (
                    i.querySelectorAll(s.el).forEach((t) => {
                        const i = g({}, s, { el: t });
                        e.push(new Swiper(i));
                    }),
                    e
                );
            }
            const r = this;
            (r.__swiper__ = !0),
                (r.support = L()),
                (r.device = k({ userAgent: s.userAgent })),
                (r.browser = M()),
                (r.eventsListeners = {}),
                (r.eventsAnyListeners = []),
                (r.modules = [...r.__modules__]),
                s.modules && Array.isArray(s.modules) && r.modules.push(...s.modules);
            const a = {};
            r.modules.forEach((e) => {
                e({ params: s, swiper: r, extendParams: Z(s, a), on: r.on.bind(r), once: r.once.bind(r), off: r.off.bind(r), emit: r.emit.bind(r) });
            });
            const n = g({}, J, a);
            return (
                (r.params = g({}, n, ee, s)),
                (r.originalParams = g({}, r.params)),
                (r.passedParams = g({}, s)),
                r.params &&
                    r.params.on &&
                    Object.keys(r.params.on).forEach((e) => {
                        r.on(e, r.params.on[e]);
                    }),
                r.params && r.params.onAny && r.onAny(r.params.onAny),
                Object.assign(r, {
                    enabled: r.params.enabled,
                    el: t,
                    classNames: [],
                    slides: [],
                    slidesGrid: [],
                    snapGrid: [],
                    slidesSizesGrid: [],
                    isHorizontal: () => "horizontal" === r.params.direction,
                    isVertical: () => "vertical" === r.params.direction,
                    activeIndex: 0,
                    realIndex: 0,
                    isBeginning: !0,
                    isEnd: !1,
                    translate: 0,
                    previousTranslate: 0,
                    progress: 0,
                    velocity: 0,
                    animating: !1,
                    cssOverflowAdjustment() {
                        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
                    },
                    allowSlideNext: r.params.allowSlideNext,
                    allowSlidePrev: r.params.allowSlidePrev,
                    touchEventsData: {
                        isTouched: void 0,
                        isMoved: void 0,
                        allowTouchCallbacks: void 0,
                        touchStartTime: void 0,
                        isScrolling: void 0,
                        currentTranslate: void 0,
                        startTranslate: void 0,
                        allowThresholdMove: void 0,
                        focusableElements: r.params.focusableElements,
                        lastClickTime: 0,
                        clickTimeout: void 0,
                        velocities: [],
                        allowMomentumBounce: void 0,
                        startMoving: void 0,
                        evCache: [],
                    },
                    allowClick: !0,
                    allowTouchMove: r.params.allowTouchMove,
                    touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
                    imagesToLoad: [],
                    imagesLoaded: 0,
                }),
                r.emit("_swiper"),
                r.params.init && r.init(),
                r
            );
        }
        getSlideIndex(e) {
            const { slidesEl: t, params: s } = this,
                i = S(v(t, `.${s.slideClass}, swiper-slide`)[0]);
            return S(e) - i;
        }
        getSlideIndexByData(e) {
            return this.getSlideIndex(this.slides.filter((t) => 1 * t.getAttribute("data-swiper-slide-index") === e)[0]);
        }
        recalcSlides() {
            const { slidesEl: e, params: t } = this;
            this.slides = v(e, `.${t.slideClass}, swiper-slide`);
        }
        enable() {
            const e = this;
            e.enabled || ((e.enabled = !0), e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
        }
        disable() {
            const e = this;
            e.enabled && ((e.enabled = !1), e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
        }
        setProgress(e, t) {
            const s = this;
            e = Math.min(Math.max(e, 0), 1);
            const i = s.minTranslate(),
                r = (s.maxTranslate() - i) * e + i;
            s.translateTo(r, void 0 === t ? 0 : t), s.updateActiveIndex(), s.updateSlidesClasses();
        }
        emitContainerClasses() {
            const e = this;
            if (!e.params._emitClasses || !e.el) return;
            const t = e.el.className.split(" ").filter((t) => 0 === t.indexOf("swiper") || 0 === t.indexOf(e.params.containerModifierClass));
            e.emit("_containerClasses", t.join(" "));
        }
        getSlideClasses(e) {
            const t = this;
            return t.destroyed
                ? ""
                : e.className
                      .split(" ")
                      .filter((e) => 0 === e.indexOf("swiper-slide") || 0 === e.indexOf(t.params.slideClass))
                      .join(" ");
        }
        emitSlidesClasses() {
            const e = this;
            if (!e.params._emitClasses || !e.el) return;
            const t = [];
            e.slides.forEach((s) => {
                const i = e.getSlideClasses(s);
                t.push({ slideEl: s, classNames: i }), e.emit("_slideClass", s, i);
            }),
                e.emit("_slideClasses", t);
        }
        slidesPerViewDynamic(e = "current", t = !1) {
            const { params: s, slides: i, slidesGrid: r, slidesSizesGrid: a, size: n, activeIndex: l } = this;
            let o = 1;
            if (s.centeredSlides) {
                let e,
                    t = i[l] ? i[l].swiperSlideSize : 0;
                for (let s = l + 1; s < i.length; s += 1) i[s] && !e && ((t += i[s].swiperSlideSize), (o += 1), t > n && (e = !0));
                for (let s = l - 1; s >= 0; s -= 1) i[s] && !e && ((t += i[s].swiperSlideSize), (o += 1), t > n && (e = !0));
            } else if ("current" === e)
                for (let e = l + 1; e < i.length; e += 1) {
                    (t ? r[e] + a[e] - r[l] < n : r[e] - r[l] < n) && (o += 1);
                }
            else
                for (let e = l - 1; e >= 0; e -= 1) {
                    r[l] - r[e] < n && (o += 1);
                }
            return o;
        }
        update() {
            const e = this;
            if (!e || e.destroyed) return;
            const { snapGrid: t, params: s } = e;
            function i() {
                const t = e.rtlTranslate ? -1 * e.translate : e.translate,
                    s = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
                e.setTranslate(s), e.updateActiveIndex(), e.updateSlidesClasses();
            }
            let r;
            if (
                (s.breakpoints && e.setBreakpoint(),
                [...e.el.querySelectorAll('[loading="lazy"]')].forEach((t) => {
                    t.complete && P(e, t);
                }),
                e.updateSize(),
                e.updateSlides(),
                e.updateProgress(),
                e.updateSlidesClasses(),
                s.freeMode && s.freeMode.enabled && !s.cssMode)
            )
                i(), s.autoHeight && e.updateAutoHeight();
            else {
                if (("auto" === s.slidesPerView || s.slidesPerView > 1) && e.isEnd && !s.centeredSlides) {
                    const t = e.virtual && s.virtual.enabled ? e.virtual.slides : e.slides;
                    r = e.slideTo(t.length - 1, 0, !1, !0);
                } else r = e.slideTo(e.activeIndex, 0, !1, !0);
                r || i();
            }
            s.watchOverflow && t !== e.snapGrid && e.checkOverflow(), e.emit("update");
        }
        changeDirection(e, t = !0) {
            const s = this,
                i = s.params.direction;
            return (
                e || (e = "horizontal" === i ? "vertical" : "horizontal"),
                e === i ||
                    ("horizontal" !== e && "vertical" !== e) ||
                    (s.el.classList.remove(`${s.params.containerModifierClass}${i}`),
                    s.el.classList.add(`${s.params.containerModifierClass}${e}`),
                    s.emitContainerClasses(),
                    (s.params.direction = e),
                    s.slides.forEach((t) => {
                        "vertical" === e ? (t.style.width = "") : (t.style.height = "");
                    }),
                    s.emit("changeDirection"),
                    t && s.update()),
                s
            );
        }
        changeLanguageDirection(e) {
            const t = this;
            (t.rtl && "rtl" === e) ||
                (!t.rtl && "ltr" === e) ||
                ((t.rtl = "rtl" === e),
                (t.rtlTranslate = "horizontal" === t.params.direction && t.rtl),
                t.rtl ? (t.el.classList.add(`${t.params.containerModifierClass}rtl`), (t.el.dir = "rtl")) : (t.el.classList.remove(`${t.params.containerModifierClass}rtl`), (t.el.dir = "ltr")),
                t.update());
        }
        mount(e) {
            const t = this;
            if (t.mounted) return !0;
            let s = e || t.params.el;
            if (("string" == typeof s && (s = document.querySelector(s)), !s)) return !1;
            (s.swiper = t), s.shadowEl && (t.isElement = !0);
            const i = () => `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
            let r = (() => {
                if (s && s.shadowRoot && s.shadowRoot.querySelector) {
                    return s.shadowRoot.querySelector(i());
                }
                return v(s, i())[0];
            })();
            return (
                !r &&
                    t.params.createElements &&
                    ((r = w("div", t.params.wrapperClass)),
                    s.append(r),
                    v(s, `.${t.params.slideClass}`).forEach((e) => {
                        r.append(e);
                    })),
                Object.assign(t, {
                    el: s,
                    wrapperEl: r,
                    slidesEl: t.isElement ? s : r,
                    mounted: !0,
                    rtl: "rtl" === s.dir.toLowerCase() || "rtl" === y(s, "direction"),
                    rtlTranslate: "horizontal" === t.params.direction && ("rtl" === s.dir.toLowerCase() || "rtl" === y(s, "direction")),
                    wrongRTL: "-webkit-box" === y(r, "display"),
                }),
                !0
            );
        }
        init(e) {
            const t = this;
            if (t.initialized) return t;
            return (
                !1 === t.mount(e) ||
                    (t.emit("beforeInit"),
                    t.params.breakpoints && t.setBreakpoint(),
                    t.addClasses(),
                    t.updateSize(),
                    t.updateSlides(),
                    t.params.watchOverflow && t.checkOverflow(),
                    t.params.grabCursor && t.enabled && t.setGrabCursor(),
                    t.params.loop && t.virtual && t.params.virtual.enabled
                        ? t.slideTo(t.params.initialSlide + t.virtual.slidesBefore, 0, t.params.runCallbacksOnInit, !1, !0)
                        : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0),
                    t.params.loop && t.loopCreate(),
                    t.attachEvents(),
                    [...t.el.querySelectorAll('[loading="lazy"]')].forEach((e) => {
                        e.complete
                            ? P(t, e)
                            : e.addEventListener("load", (e) => {
                                  P(t, e.target);
                              });
                    }),
                    G(t),
                    (t.initialized = !0),
                    G(t),
                    t.emit("init"),
                    t.emit("afterInit")),
                t
            );
        }
        destroy(e = !0, t = !0) {
            const s = this,
                { params: i, el: r, wrapperEl: a, slides: n } = s;
            return (
                void 0 === s.params ||
                    s.destroyed ||
                    (s.emit("beforeDestroy"),
                    (s.initialized = !1),
                    s.detachEvents(),
                    i.loop && s.loopDestroy(),
                    t &&
                        (s.removeClasses(),
                        r.removeAttribute("style"),
                        a.removeAttribute("style"),
                        n &&
                            n.length &&
                            n.forEach((e) => {
                                e.classList.remove(i.slideVisibleClass, i.slideActiveClass, i.slideNextClass, i.slidePrevClass), e.removeAttribute("style"), e.removeAttribute("data-swiper-slide-index");
                            })),
                    s.emit("destroy"),
                    Object.keys(s.eventsListeners).forEach((e) => {
                        s.off(e);
                    }),
                    !1 !== e &&
                        ((s.el.swiper = null),
                        (function (e) {
                            const t = e;
                            Object.keys(t).forEach((e) => {
                                try {
                                    t[e] = null;
                                } catch (e) {}
                                try {
                                    delete t[e];
                                } catch (e) {}
                            });
                        })(s)),
                    (s.destroyed = !0)),
                null
            );
        }
        static extendDefaults(e) {
            g(ee, e);
        }
        static get extendedDefaults() {
            return ee;
        }
        static get defaults() {
            return J;
        }
        static installModule(e) {
            Swiper.prototype.__modules__ || (Swiper.prototype.__modules__ = []);
            const t = Swiper.prototype.__modules__;
            "function" == typeof e && t.indexOf(e) < 0 && t.push(e);
        }
        static use(e) {
            return Array.isArray(e) ? (e.forEach((e) => Swiper.installModule(e)), Swiper) : (Swiper.installModule(e), Swiper);
        }
    }
    Object.keys(K).forEach((e) => {
        Object.keys(K[e]).forEach((t) => {
            Swiper.prototype[t] = K[e][t];
        });
    }),
        Swiper.use([
            function ({ swiper: e, on: t, emit: s }) {
                const i = d();
                let r = null,
                    a = null;
                const n = () => {
                        e && !e.destroyed && e.initialized && (s("beforeResize"), s("resize"));
                    },
                    l = () => {
                        e && !e.destroyed && e.initialized && s("orientationchange");
                    };
                t("init", () => {
                    e.params.resizeObserver && void 0 !== i.ResizeObserver
                        ? e &&
                          !e.destroyed &&
                          e.initialized &&
                          ((r = new ResizeObserver((t) => {
                              a = i.requestAnimationFrame(() => {
                                  const { width: s, height: i } = e;
                                  let r = s,
                                      a = i;
                                  t.forEach(({ contentBoxSize: t, contentRect: s, target: i }) => {
                                      (i && i !== e.el) || ((r = s ? s.width : (t[0] || t).inlineSize), (a = s ? s.height : (t[0] || t).blockSize));
                                  }),
                                      (r === s && a === i) || n();
                              });
                          })),
                          r.observe(e.el))
                        : (i.addEventListener("resize", n), i.addEventListener("orientationchange", l));
                }),
                    t("destroy", () => {
                        a && i.cancelAnimationFrame(a), r && r.unobserve && e.el && (r.unobserve(e.el), (r = null)), i.removeEventListener("resize", n), i.removeEventListener("orientationchange", l);
                    });
            },
            function ({ swiper: e, extendParams: t, on: s, emit: i }) {
                const r = [],
                    a = d(),
                    n = (t, s = {}) => {
                        const n = new (a.MutationObserver || a.WebkitMutationObserver)((t) => {
                            if (e.__preventObserver__) return;
                            if (1 === t.length) return void i("observerUpdate", t[0]);
                            const s = function () {
                                i("observerUpdate", t[0]);
                            };
                            a.requestAnimationFrame ? a.requestAnimationFrame(s) : a.setTimeout(s, 0);
                        });
                        n.observe(t, { attributes: void 0 === s.attributes || s.attributes, childList: void 0 === s.childList || s.childList, characterData: void 0 === s.characterData || s.characterData }), r.push(n);
                    };
                t({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
                    s("init", () => {
                        if (e.params.observer) {
                            if (e.params.observeParents) {
                                const t = A(e.el);
                                for (let e = 0; e < t.length; e += 1) n(t[e]);
                            }
                            n(e.el, { childList: e.params.observeSlideChildren }), n(e.wrapperEl, { attributes: !1 });
                        }
                    }),
                    s("destroy", () => {
                        r.forEach((e) => {
                            e.disconnect();
                        }),
                            r.splice(0, r.length);
                    });
            },
        ]);
    const te = Swiper;
    function se(e, t, s, i) {
        return (
            e.params.createElements &&
                Object.keys(i).forEach((r) => {
                    if (!s[r] && !0 === s.auto) {
                        let a = v(e.el, `.${i[r]}`)[0];
                        a || ((a = w("div", i[r])), (a.className = i[r]), e.el.append(a)), (s[r] = a), (t[r] = a);
                    }
                }),
            s
        );
    }
    function ie({ swiper: e, extendParams: t, on: s, emit: i }) {
        t({
            navigation: { nextEl: null, prevEl: null, hideOnClick: !1, disabledClass: "swiper-button-disabled", hiddenClass: "swiper-button-hidden", lockClass: "swiper-button-lock", navigationDisabledClass: "swiper-navigation-disabled" },
        }),
            (e.navigation = { nextEl: null, prevEl: null });
        const r = (e) => (Array.isArray(e) || (e = [e].filter((e) => !!e)), e);
        function a(t) {
            let s;
            return t && "string" == typeof t && e.isElement && ((s = e.el.shadowRoot.querySelector(t)), s)
                ? s
                : (t && ("string" == typeof t && (s = [...document.querySelectorAll(t)]), e.params.uniqueNavElements && "string" == typeof t && s.length > 1 && 1 === e.el.querySelectorAll(t).length && (s = e.el.querySelector(t))),
                  t && !s ? t : s);
        }
        function n(t, s) {
            const i = e.params.navigation;
            (t = r(t)).forEach((t) => {
                t && (t.classList[s ? "add" : "remove"](...i.disabledClass.split(" ")), "BUTTON" === t.tagName && (t.disabled = s), e.params.watchOverflow && e.enabled && t.classList[e.isLocked ? "add" : "remove"](i.lockClass));
            });
        }
        function l() {
            const { nextEl: t, prevEl: s } = e.navigation;
            if (e.params.loop) return n(s, !1), void n(t, !1);
            n(s, e.isBeginning && !e.params.rewind), n(t, e.isEnd && !e.params.rewind);
        }
        function o(t) {
            t.preventDefault(), (!e.isBeginning || e.params.loop || e.params.rewind) && (e.slidePrev(), i("navigationPrev"));
        }
        function c(t) {
            t.preventDefault(), (!e.isEnd || e.params.loop || e.params.rewind) && (e.slideNext(), i("navigationNext"));
        }
        function d() {
            const t = e.params.navigation;
            if (((e.params.navigation = se(e, e.originalParams.navigation, e.params.navigation, { nextEl: "swiper-button-next", prevEl: "swiper-button-prev" })), !t.nextEl && !t.prevEl)) return;
            let s = a(t.nextEl),
                i = a(t.prevEl);
            Object.assign(e.navigation, { nextEl: s, prevEl: i }), (s = r(s)), (i = r(i));
            const n = (s, i) => {
                s && s.addEventListener("click", "next" === i ? c : o), !e.enabled && s && s.classList.add(...t.lockClass.split(" "));
            };
            s.forEach((e) => n(e, "next")), i.forEach((e) => n(e, "prev"));
        }
        function p() {
            let { nextEl: t, prevEl: s } = e.navigation;
            (t = r(t)), (s = r(s));
            const i = (t, s) => {
                t.removeEventListener("click", "next" === s ? c : o), t.classList.remove(...e.params.navigation.disabledClass.split(" "));
            };
            t.forEach((e) => i(e, "next")), s.forEach((e) => i(e, "prev"));
        }
        s("init", () => {
            !1 === e.params.navigation.enabled ? u() : (d(), l());
        }),
            s("toEdge fromEdge lock unlock", () => {
                l();
            }),
            s("destroy", () => {
                p();
            }),
            s("enable disable", () => {
                let { nextEl: t, prevEl: s } = e.navigation;
                (t = r(t)), (s = r(s)), [...t, ...s].filter((e) => !!e).forEach((t) => t.classList[e.enabled ? "remove" : "add"](e.params.navigation.lockClass));
            }),
            s("click", (t, s) => {
                let { nextEl: a, prevEl: n } = e.navigation;
                (a = r(a)), (n = r(n));
                const l = s.target;
                if (e.params.navigation.hideOnClick && !n.includes(l) && !a.includes(l)) {
                    if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === l || e.pagination.el.contains(l))) return;
                    let t;
                    a.length ? (t = a[0].classList.contains(e.params.navigation.hiddenClass)) : n.length && (t = n[0].classList.contains(e.params.navigation.hiddenClass)),
                        i(!0 === t ? "navigationShow" : "navigationHide"),
                        [...a, ...n].filter((e) => !!e).forEach((t) => t.classList.toggle(e.params.navigation.hiddenClass));
                }
            });
        const u = () => {
            e.el.classList.add(...e.params.navigation.navigationDisabledClass.split(" ")), p();
        };
        Object.assign(e.navigation, {
            enable: () => {
                e.el.classList.remove(...e.params.navigation.navigationDisabledClass.split(" ")), d(), l();
            },
            disable: u,
            update: l,
            init: d,
            destroy: p,
        });
    }
    function re(e = "") {
        return `.${e
            .trim()
            .replace(/([\.:!+\/])/g, "\\$1")
            .replace(/ /g, ".")}`;
    }
    function ae({ swiper: e, extendParams: t, on: s, emit: i }) {
        const r = "swiper-pagination";
        let a;
        t({
            pagination: {
                el: null,
                bulletElement: "span",
                clickable: !1,
                hideOnClick: !1,
                renderBullet: null,
                renderProgressbar: null,
                renderFraction: null,
                renderCustom: null,
                progressbarOpposite: !1,
                type: "bullets",
                dynamicBullets: !1,
                dynamicMainBullets: 1,
                formatFractionCurrent: (e) => e,
                formatFractionTotal: (e) => e,
                bulletClass: `${r}-bullet`,
                bulletActiveClass: `${r}-bullet-active`,
                modifierClass: `${r}-`,
                currentClass: `${r}-current`,
                totalClass: `${r}-total`,
                hiddenClass: `${r}-hidden`,
                progressbarFillClass: `${r}-progressbar-fill`,
                progressbarOppositeClass: `${r}-progressbar-opposite`,
                clickableClass: `${r}-clickable`,
                lockClass: `${r}-lock`,
                horizontalClass: `${r}-horizontal`,
                verticalClass: `${r}-vertical`,
                paginationDisabledClass: `${r}-disabled`,
            },
        }),
            (e.pagination = { el: null, bullets: [] });
        let n = 0;
        const l = (e) => (Array.isArray(e) || (e = [e].filter((e) => !!e)), e);
        function o() {
            return !e.params.pagination.el || !e.pagination.el || (Array.isArray(e.pagination.el) && 0 === e.pagination.el.length);
        }
        function c(t, s) {
            const { bulletActiveClass: i } = e.params.pagination;
            t && (t = t[("prev" === s ? "previous" : "next") + "ElementSibling"]) && (t.classList.add(`${i}-${s}`), (t = t[("prev" === s ? "previous" : "next") + "ElementSibling"]) && t.classList.add(`${i}-${s}-${s}`));
        }
        function d(t) {
            const s = t.target.closest(re(e.params.pagination.bulletClass));
            if (!s) return;
            t.preventDefault();
            const i = S(s) * e.params.slidesPerGroup;
            if (e.params.loop) {
                if (e.realIndex === i) return;
                const t = e.getSlideIndexByData(i),
                    s = e.getSlideIndexByData(e.realIndex);
                t > e.slides.length - e.loopedSlides && e.loopFix({ direction: t > s ? "next" : "prev", activeSlideIndex: t, slideTo: !1 }), e.slideToLoop(i);
            } else e.slideTo(i);
        }
        function p() {
            const t = e.rtl,
                s = e.params.pagination;
            if (o()) return;
            let r,
                d,
                p = e.pagination.el;
            p = l(p);
            const u = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
                h = e.params.loop ? Math.ceil(u / e.params.slidesPerGroup) : e.snapGrid.length;
            if (
                (e.params.loop
                    ? ((d = e.previousRealIndex || 0), (r = e.params.slidesPerGroup > 1 ? Math.floor(e.realIndex / e.params.slidesPerGroup) : e.realIndex))
                    : void 0 !== e.snapIndex
                    ? ((r = e.snapIndex), (d = e.previousSnapIndex))
                    : ((d = e.previousIndex || 0), (r = e.activeIndex || 0)),
                "bullets" === s.type && e.pagination.bullets && e.pagination.bullets.length > 0)
            ) {
                const i = e.pagination.bullets;
                let l, o, u;
                if (
                    (s.dynamicBullets &&
                        ((a = E(i[0], e.isHorizontal() ? "width" : "height", !0)),
                        p.forEach((t) => {
                            t.style[e.isHorizontal() ? "width" : "height"] = a * (s.dynamicMainBullets + 4) + "px";
                        }),
                        s.dynamicMainBullets > 1 && void 0 !== d && ((n += r - (d || 0)), n > s.dynamicMainBullets - 1 ? (n = s.dynamicMainBullets - 1) : n < 0 && (n = 0)),
                        (l = Math.max(r - n, 0)),
                        (o = l + (Math.min(i.length, s.dynamicMainBullets) - 1)),
                        (u = (o + l) / 2)),
                    i.forEach((e) => {
                        const t = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((e) => `${s.bulletActiveClass}${e}`)].map((e) => ("string" == typeof e && e.includes(" ") ? e.split(" ") : e)).flat();
                        e.classList.remove(...t);
                    }),
                    p.length > 1)
                )
                    i.forEach((t) => {
                        const i = S(t);
                        i === r ? t.classList.add(...s.bulletActiveClass.split(" ")) : e.isElement && t.setAttribute("part", "bullet"),
                            s.dynamicBullets && (i >= l && i <= o && t.classList.add(...`${s.bulletActiveClass}-main`.split(" ")), i === l && c(t, "prev"), i === o && c(t, "next"));
                    });
                else {
                    const t = i[r];
                    if (
                        (t && t.classList.add(...s.bulletActiveClass.split(" ")),
                        e.isElement &&
                            i.forEach((e, t) => {
                                e.setAttribute("part", t === r ? "bullet-active" : "bullet");
                            }),
                        s.dynamicBullets)
                    ) {
                        const e = i[l],
                            t = i[o];
                        for (let e = l; e <= o; e += 1) i[e] && i[e].classList.add(...`${s.bulletActiveClass}-main`.split(" "));
                        c(e, "prev"), c(t, "next");
                    }
                }
                if (s.dynamicBullets) {
                    const r = Math.min(i.length, s.dynamicMainBullets + 4),
                        n = (a * r - a) / 2 - u * a,
                        l = t ? "right" : "left";
                    i.forEach((t) => {
                        t.style[e.isHorizontal() ? l : "top"] = `${n}px`;
                    });
                }
            }
            p.forEach((t, a) => {
                if (
                    ("fraction" === s.type &&
                        (t.querySelectorAll(re(s.currentClass)).forEach((e) => {
                            e.textContent = s.formatFractionCurrent(r + 1);
                        }),
                        t.querySelectorAll(re(s.totalClass)).forEach((e) => {
                            e.textContent = s.formatFractionTotal(h);
                        })),
                    "progressbar" === s.type)
                ) {
                    let i;
                    i = s.progressbarOpposite ? (e.isHorizontal() ? "vertical" : "horizontal") : e.isHorizontal() ? "horizontal" : "vertical";
                    const a = (r + 1) / h;
                    let n = 1,
                        l = 1;
                    "horizontal" === i ? (n = a) : (l = a),
                        t.querySelectorAll(re(s.progressbarFillClass)).forEach((t) => {
                            (t.style.transform = `translate3d(0,0,0) scaleX(${n}) scaleY(${l})`), (t.style.transitionDuration = `${e.params.speed}ms`);
                        });
                }
                "custom" === s.type && s.renderCustom ? ((t.innerHTML = s.renderCustom(e, r + 1, h)), 0 === a && i("paginationRender", t)) : (0 === a && i("paginationRender", t), i("paginationUpdate", t)),
                    e.params.watchOverflow && e.enabled && t.classList[e.isLocked ? "add" : "remove"](s.lockClass);
            });
        }
        function u() {
            const t = e.params.pagination;
            if (o()) return;
            const s = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length;
            let r = e.pagination.el;
            r = l(r);
            let a = "";
            if ("bullets" === t.type) {
                let i = e.params.loop ? Math.ceil(s / e.params.slidesPerGroup) : e.snapGrid.length;
                e.params.freeMode && e.params.freeMode.enabled && i > s && (i = s);
                for (let s = 0; s < i; s += 1) t.renderBullet ? (a += t.renderBullet.call(e, s, t.bulletClass)) : (a += `<${t.bulletElement} ${e.isElement ? 'part="bullet"' : ""} class="${t.bulletClass}"></${t.bulletElement}>`);
            }
            "fraction" === t.type && (a = t.renderFraction ? t.renderFraction.call(e, t.currentClass, t.totalClass) : `<span class="${t.currentClass}"></span> / <span class="${t.totalClass}"></span>`),
                "progressbar" === t.type && (a = t.renderProgressbar ? t.renderProgressbar.call(e, t.progressbarFillClass) : `<span class="${t.progressbarFillClass}"></span>`),
                (e.pagination.bullets = []),
                r.forEach((s) => {
                    "custom" !== t.type && (s.innerHTML = a || ""), "bullets" === t.type && e.pagination.bullets.push(...s.querySelectorAll(re(t.bulletClass)));
                }),
                "custom" !== t.type && i("paginationRender", r[0]);
        }
        function h() {
            e.params.pagination = se(e, e.originalParams.pagination, e.params.pagination, { el: "swiper-pagination" });
            const t = e.params.pagination;
            if (!t.el) return;
            let s;
            "string" == typeof t.el && e.isElement && (s = e.el.shadowRoot.querySelector(t.el)),
                s || "string" != typeof t.el || (s = [...document.querySelectorAll(t.el)]),
                s || (s = t.el),
                s &&
                    0 !== s.length &&
                    (e.params.uniqueNavElements && "string" == typeof t.el && Array.isArray(s) && s.length > 1 && ((s = [...e.el.querySelectorAll(t.el)]), s.length > 1 && (s = s.filter((t) => A(t, ".swiper")[0] === e.el)[0])),
                    Array.isArray(s) && 1 === s.length && (s = s[0]),
                    Object.assign(e.pagination, { el: s }),
                    (s = l(s)),
                    s.forEach((s) => {
                        "bullets" === t.type && t.clickable && s.classList.add(t.clickableClass),
                            s.classList.add(t.modifierClass + t.type),
                            s.classList.add(e.isHorizontal() ? t.horizontalClass : t.verticalClass),
                            "bullets" === t.type && t.dynamicBullets && (s.classList.add(`${t.modifierClass}${t.type}-dynamic`), (n = 0), t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)),
                            "progressbar" === t.type && t.progressbarOpposite && s.classList.add(t.progressbarOppositeClass),
                            t.clickable && s.addEventListener("click", d),
                            e.enabled || s.classList.add(t.lockClass);
                    }));
        }
        function m() {
            const t = e.params.pagination;
            if (o()) return;
            let s = e.pagination.el;
            s &&
                ((s = l(s)),
                s.forEach((s) => {
                    s.classList.remove(t.hiddenClass), s.classList.remove(t.modifierClass + t.type), s.classList.remove(e.isHorizontal() ? t.horizontalClass : t.verticalClass), t.clickable && s.removeEventListener("click", d);
                })),
                e.pagination.bullets && e.pagination.bullets.forEach((e) => e.classList.remove(...t.bulletActiveClass.split(" ")));
        }
        s("changeDirection", () => {
            if (!e.pagination || !e.pagination.el) return;
            const t = e.params.pagination;
            let { el: s } = e.pagination;
            (s = l(s)),
                s.forEach((s) => {
                    s.classList.remove(t.horizontalClass, t.verticalClass), s.classList.add(e.isHorizontal() ? t.horizontalClass : t.verticalClass);
                });
        }),
            s("init", () => {
                !1 === e.params.pagination.enabled ? g() : (h(), u(), p());
            }),
            s("activeIndexChange", () => {
                void 0 === e.snapIndex && p();
            }),
            s("snapIndexChange", () => {
                p();
            }),
            s("snapGridLengthChange", () => {
                u(), p();
            }),
            s("destroy", () => {
                m();
            }),
            s("enable disable", () => {
                let { el: t } = e.pagination;
                t && ((t = l(t)), t.forEach((t) => t.classList[e.enabled ? "remove" : "add"](e.params.pagination.lockClass)));
            }),
            s("lock unlock", () => {
                p();
            }),
            s("click", (t, s) => {
                const r = s.target;
                let { el: a } = e.pagination;
                if ((Array.isArray(a) || (a = [a].filter((e) => !!e)), e.params.pagination.el && e.params.pagination.hideOnClick && a && a.length > 0 && !r.classList.contains(e.params.pagination.bulletClass))) {
                    if (e.navigation && ((e.navigation.nextEl && r === e.navigation.nextEl) || (e.navigation.prevEl && r === e.navigation.prevEl))) return;
                    const t = a[0].classList.contains(e.params.pagination.hiddenClass);
                    i(!0 === t ? "paginationShow" : "paginationHide"), a.forEach((t) => t.classList.toggle(e.params.pagination.hiddenClass));
                }
            });
        const g = () => {
            e.el.classList.add(e.params.pagination.paginationDisabledClass);
            let { el: t } = e.pagination;
            t && ((t = l(t)), t.forEach((t) => t.classList.add(e.params.pagination.paginationDisabledClass))), m();
        };
        Object.assign(e.pagination, {
            enable: () => {
                e.el.classList.remove(e.params.pagination.paginationDisabledClass);
                let { el: t } = e.pagination;
                t && ((t = l(t)), t.forEach((t) => t.classList.remove(e.params.pagination.paginationDisabledClass))), h(), u(), p();
            },
            disable: g,
            render: u,
            update: p,
            init: h,
            destroy: m,
        });
    }
    function ne({ swiper: e, extendParams: t, on: s, emit: i }) {
        const r = o();
        let a,
            n,
            l,
            c,
            u = !1,
            h = null,
            m = null;
        function g() {
            if (!e.params.scrollbar.el || !e.scrollbar.el) return;
            const { scrollbar: t, rtlTranslate: s } = e,
                { dragEl: i, el: r } = t,
                a = e.params.scrollbar,
                o = e.params.loop ? e.progressLoop : e.progress;
            let c = n,
                d = (l - n) * o;
            s ? ((d = -d), d > 0 ? ((c = n - d), (d = 0)) : -d + n > l && (c = l + d)) : d < 0 ? ((c = n + d), (d = 0)) : d + n > l && (c = l - d),
                e.isHorizontal() ? ((i.style.transform = `translate3d(${d}px, 0, 0)`), (i.style.width = `${c}px`)) : ((i.style.transform = `translate3d(0px, ${d}px, 0)`), (i.style.height = `${c}px`)),
                a.hide &&
                    (clearTimeout(h),
                    (r.style.opacity = 1),
                    (h = setTimeout(() => {
                        (r.style.opacity = 0), (r.style.transitionDuration = "400ms");
                    }, 1e3)));
        }
        function f() {
            if (!e.params.scrollbar.el || !e.scrollbar.el) return;
            const { scrollbar: t } = e,
                { dragEl: s, el: i } = t;
            (s.style.width = ""),
                (s.style.height = ""),
                (l = e.isHorizontal() ? i.offsetWidth : i.offsetHeight),
                (c = e.size / (e.virtualSize + e.params.slidesOffsetBefore - (e.params.centeredSlides ? e.snapGrid[0] : 0))),
                (n = "auto" === e.params.scrollbar.dragSize ? l * c : parseInt(e.params.scrollbar.dragSize, 10)),
                e.isHorizontal() ? (s.style.width = `${n}px`) : (s.style.height = `${n}px`),
                (i.style.display = c >= 1 ? "none" : ""),
                e.params.scrollbar.hide && (i.style.opacity = 0),
                e.params.watchOverflow && e.enabled && t.el.classList[e.isLocked ? "add" : "remove"](e.params.scrollbar.lockClass);
        }
        function b(t) {
            return e.isHorizontal() ? t.clientX : t.clientY;
        }
        function v(t) {
            const { scrollbar: s, rtlTranslate: i } = e,
                { el: r } = s;
            let c;
            (c =
                (b(t) -
                    (function (e) {
                        const t = d(),
                            s = o(),
                            i = e.getBoundingClientRect(),
                            r = s.body,
                            a = e.clientTop || r.clientTop || 0,
                            n = e.clientLeft || r.clientLeft || 0,
                            l = e === t ? t.scrollY : e.scrollTop,
                            c = e === t ? t.scrollX : e.scrollLeft;
                        return { top: i.top + l - a, left: i.left + c - n };
                    })(r)[e.isHorizontal() ? "left" : "top"] -
                    (null !== a ? a : n / 2)) /
                (l - n)),
                (c = Math.max(Math.min(c, 1), 0)),
                i && (c = 1 - c);
            const p = e.minTranslate() + (e.maxTranslate() - e.minTranslate()) * c;
            e.updateProgress(p), e.setTranslate(p), e.updateActiveIndex(), e.updateSlidesClasses();
        }
        function y(t) {
            const s = e.params.scrollbar,
                { scrollbar: r, wrapperEl: n } = e,
                { el: l, dragEl: o } = r;
            (u = !0),
                (a = t.target === o ? b(t) - t.target.getBoundingClientRect()[e.isHorizontal() ? "left" : "top"] : null),
                t.preventDefault(),
                t.stopPropagation(),
                (n.style.transitionDuration = "100ms"),
                (o.style.transitionDuration = "100ms"),
                v(t),
                clearTimeout(m),
                (l.style.transitionDuration = "0ms"),
                s.hide && (l.style.opacity = 1),
                e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "none"),
                i("scrollbarDragStart", t);
        }
        function S(t) {
            const { scrollbar: s, wrapperEl: r } = e,
                { el: a, dragEl: n } = s;
            u && (t.preventDefault ? t.preventDefault() : (t.returnValue = !1), v(t), (r.style.transitionDuration = "0ms"), (a.style.transitionDuration = "0ms"), (n.style.transitionDuration = "0ms"), i("scrollbarDragMove", t));
        }
        function A(t) {
            const s = e.params.scrollbar,
                { scrollbar: r, wrapperEl: a } = e,
                { el: n } = r;
            u &&
                ((u = !1),
                e.params.cssMode && ((e.wrapperEl.style["scroll-snap-type"] = ""), (a.style.transitionDuration = "")),
                s.hide &&
                    (clearTimeout(m),
                    (m = p(() => {
                        (n.style.opacity = 0), (n.style.transitionDuration = "400ms");
                    }, 1e3))),
                i("scrollbarDragEnd", t),
                s.snapOnRelease && e.slideToClosest());
        }
        function E(t) {
            const { scrollbar: s, params: i } = e,
                a = s.el;
            if (!a) return;
            const n = a,
                l = !!i.passiveListeners && { passive: !1, capture: !1 },
                o = !!i.passiveListeners && { passive: !0, capture: !1 };
            if (!n) return;
            const c = "on" === t ? "addEventListener" : "removeEventListener";
            n[c]("pointerdown", y, l), r[c]("pointermove", S, l), r[c]("pointerup", A, o);
        }
        function x() {
            const { scrollbar: t, el: s } = e;
            e.params.scrollbar = se(e, e.originalParams.scrollbar, e.params.scrollbar, { el: "swiper-scrollbar" });
            const i = e.params.scrollbar;
            if (!i.el) return;
            let a, n;
            "string" == typeof i.el && e.isElement && (a = e.el.shadowRoot.querySelector(i.el)),
                a || "string" != typeof i.el ? a || (a = i.el) : (a = r.querySelectorAll(i.el)),
                e.params.uniqueNavElements && "string" == typeof i.el && a.length > 1 && 1 === s.querySelectorAll(i.el).length && (a = s.querySelector(i.el)),
                a.length > 0 && (a = a[0]),
                a.classList.add(e.isHorizontal() ? i.horizontalClass : i.verticalClass),
                a && ((n = a.querySelector(`.${e.params.scrollbar.dragClass}`)), n || ((n = w("div", e.params.scrollbar.dragClass)), a.append(n))),
                Object.assign(t, { el: a, dragEl: n }),
                i.draggable && e.params.scrollbar.el && e.scrollbar.el && E("on"),
                a && a.classList[e.enabled ? "remove" : "add"](e.params.scrollbar.lockClass);
        }
        function C() {
            const t = e.params.scrollbar,
                s = e.scrollbar.el;
            s && s.classList.remove(e.isHorizontal() ? t.horizontalClass : t.verticalClass), e.params.scrollbar.el && e.scrollbar.el && E("off");
        }
        t({
            scrollbar: {
                el: null,
                dragSize: "auto",
                hide: !1,
                draggable: !1,
                snapOnRelease: !0,
                lockClass: "swiper-scrollbar-lock",
                dragClass: "swiper-scrollbar-drag",
                scrollbarDisabledClass: "swiper-scrollbar-disabled",
                horizontalClass: "swiper-scrollbar-horizontal",
                verticalClass: "swiper-scrollbar-vertical",
            },
        }),
            (e.scrollbar = { el: null, dragEl: null }),
            s("init", () => {
                !1 === e.params.scrollbar.enabled ? T() : (x(), f(), g());
            }),
            s("update resize observerUpdate lock unlock", () => {
                f();
            }),
            s("setTranslate", () => {
                g();
            }),
            s("setTransition", (t, s) => {
                !(function (t) {
                    e.params.scrollbar.el && e.scrollbar.el && (e.scrollbar.dragEl.style.transitionDuration = `${t}ms`);
                })(s);
            }),
            s("enable disable", () => {
                const { el: t } = e.scrollbar;
                t && t.classList[e.enabled ? "remove" : "add"](e.params.scrollbar.lockClass);
            }),
            s("destroy", () => {
                C();
            });
        const T = () => {
            e.el.classList.add(e.params.scrollbar.scrollbarDisabledClass), e.scrollbar.el && e.scrollbar.el.classList.add(e.params.scrollbar.scrollbarDisabledClass), C();
        };
        Object.assign(e.scrollbar, {
            enable: () => {
                e.el.classList.remove(e.params.scrollbar.scrollbarDisabledClass), e.scrollbar.el && e.scrollbar.el.classList.remove(e.params.scrollbar.scrollbarDisabledClass), x(), f(), g();
            },
            disable: T,
            updateSize: f,
            setTranslate: g,
            init: x,
            destroy: C,
        });
    }
    class GlobalCartUpsells extends HTMLElement {
        constructor() {
            super(), (this.ObserverLite = new ObserverLite());
        }
        subscribe(e) {
            return this.ObserverLite.subscribe(e);
        }
        next(e) {
            this.ObserverLite.next(e);
        }
        connectedCallback() {
            r()
                .then(async () => {
                    this.GlobalCart = await new GlobalCart();
                    const e = this.querySelector("template");
                    if (e) {
                        try {
                            (this.settings = JSON.parse(e.innerHTML)), e.remove();
                        } catch (e) {
                            console.log(e);
                        }
                        if (this.settings) {
                            if (
                                ((this.settings.layout = { items_in_view: 1, space_between: 12, ...(this.settings.layout || {}) }),
                                (this.settings.upsell_blocks = this.settings.upsell_blocks
                                    .map((e, t) => {
                                        const s = { offer_id: e.id, variant_ids: e.logic_cart_content_variant_ids };
                                        (e.order = e.order || t),
                                            (e.upsells = e.upsells
                                                .map((e) => ((e.variants = e.variants.filter(({ available: e, id: t }) => e)), e))
                                                .filter(({ variants: e }) => e.length && !this.cartHasVariants(e.map(({ id: e }) => e)).length));
                                        let i = !0;
                                        const r = s.variant_ids || [];
                                        return (i = !r.length || this.cartHasVariants(r)?.length), !(!i || !e.upsells.length) && e;
                                    })
                                    .filter((e) => e)
                                    .sort((e, t) => e.order - t.order)),
                                !this.settings.upsell_blocks.length)
                            )
                                return void this.remove();
                            (this.active = this.settings.upsell_blocks[0]), this.mount(), this.updateHTML();
                        }
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        }
        mount() {
            if (!window.GloblCartUpsellsMounted) {
                const e =
                    '\n        <style type="text/css">\n\n          .cart-upsell-thumb__img{\n            width:80px;\n          }\n  \n          .cart-upsell-thumb__form{\n            width:calc(100% - 80px);\n            padding-left:var(--gutter-unit-d2);\n          }\n\n          .cart-upsell-thumb__select{\n            padding:3px;\n            border: none;\n            outline: none;\n            background: #f1f1f1;\n          }\n\n          .swiper-scrollbar.cart-upsell-thumb__scrollbar{\n            margin-top:0;\n          }\n        </style>\n      ';
                (window.GloblCartUpsellsMounted = !0), document.body.append(s(e));
            }
        }
        cartHasVariants(e) {
            if (!this.GlobalCart) return !1;
            return e.filter((e) => this.GlobalCart.cart.items.find((t) => t.variant_id == e));
        }
        async updateHTML() {
            const { active: e } = this;
            this.innerHTML = `\n      <div class="flex column-nowrap flex-grid--d2">\n        <div class="block-12/12 flex row-wrap flex-grid--d2 justify-space align-center tal">\n          ${
                e.heading?.length ? `<h2 class="h-style t-s t-ucase f-w500">${e.heading}</h2>` : ""
            }\n        </div>\n        <swiper-container init="false">\n          ${e.upsells
                .map((e) => {
                    const t = e.variants[0];
                    return `\n                <swiper-slide>\n                  <global-cart-upsell-thumb class="upsell-thumb-wrapper flex row-wrap align-center justify-left block-12/12">\n                    <a href="/products/${
                        e.handle
                    }" class="cart-upsell-thumb__img d-block block-rel lh-m">\n                      <img src="${e.featured_image}?w=128" alt="${
                        e.title
                    }" width="128" height="128" loading="lazy">\n                    </a>\n                    <form class="js-upsell-thumb__form cart-upsell-thumb__form flex tal row-wrap align-center" \n                          action="/cart/add" \n                          method="post" \n                          enctype="multipart/form-data">\n                      <div class="flex flex-grid-y--d3 row-wrap block-9/12">\n                        <span class="h-style t-xs block-12/12 lh-r">${
                        e.title
                    }</span>\n                        <div class="js-upsell-thumb__price t-xs block-12/12 lh-r f-w500"></div>\n                        <input type="hidden" value="1" name="qty">\n                        ${
                        1 == e.variants.length
                            ? `<input type="hidden" \n                                  name="id" \n                                  value="${t.id}"\n                                  data-variant='${JSON.stringify({
                                  id: t.id,
                                  price: this.GlobalCart.ShopifyUtils.formatMoney(t.price),
                                  compare_at_price: this.GlobalCart.ShopifyUtils.formatMoney(t.compare_at_price),
                              })}'>`
                            : ` \n                            <select name="id" class="cart-upsell-thumb__select">\n                            ${e.variants.map(
                                  (e) => `<option value="${e.id}" data-variant='${JSON.stringify({ id: e.id, price: e.price, compare_at_price: e.compare_at_price })}'>${e.title}</option>`
                              )}\n                            </select>\n                          `
                    }\n                      </div>\n                      <div class="block-3/12">\n                        <button class="btn btn--square btn--xs block-r">${
                        this.settings.translations.thumbnail_add
                    }</button>\n                      </div>\n                    </form>\n\n                  </global-cart-upsell-thumb>     \n                </swiper-slide>  \n              `;
                })
                .join("")}\n        </swiper-container>\n        <div class="swiper-pagination"></div>\n        <div class="cart-upsell-thumb__scrollbar swiper-scrollbar swiper-scrollbar--relative"></div>\n      </div>\n    `;
            const t = this.querySelector("swiper-container");
            Object.assign(t, { slidesPerView: 1, pagination: { el: this.querySelector(".swiper-pagination"), clickable: !0 }, scrollbar: { el: this.querySelector(".swiper-scrollbar"), draggable: !0 }, modules: [ne, ae] }), t.initialize();
        }
    }
    customElements.define("global-cart-upsells", GlobalCartUpsells);
    class GlobalCartUpsellThumb extends HTMLElement {
        constructor() {
            super(), (this.ObserverLite = new ObserverLite());
        }
        subscribe(e) {
            return this.ObserverLite.subscribe(e);
        }
        next(e) {
            this.ObserverLite.next(e);
        }
        connectedCallback() {
            r()
                .then(async () => {
                    (this.GlobalCart = await new GlobalCart()), this.bind();
                })
                .catch((e) => {
                    console.log(e);
                });
        }
        bind() {
            (this.ui = { form: this.querySelector("form"), price: this.querySelector(".js-upsell-thumb__price"), atc: this.querySelector("button"), variantSelector: this.querySelector('[name="id"]') }),
                this.ui.variantSelector.addEventListener("change", () => {
                    this.onVariantChange();
                }),
                this.onVariantChange(),
                this.ui.form.addEventListener("submit", (e) => (e.preventDefault(), this.GlobalCart.addViaForm(this.ui.form), !1));
        }
        onVariantChange() {
            const { variantSelector: e, price: t } = this.ui,
                s = JSON.parse("SELECT" == e.tagName ? e.options[e.selectedIndex].dataset?.variant || null : e.datset?.variant || null);
            s &&
                (t.innerHTML = s.compare_at_price
                    ? `\n        <span class="t-red">${this.GlobalCart.ShopifyUtils.formatMoney(s.price)}</span>\n        <span class=""cell-l--d4 t-grey"><strike>${this.GlobalCart.ShopifyUtils.formatMoney(
                          s.compare_at_price
                      )}</strike></span>\n      `
                    : `\n        <span>${this.GlobalCart.ShopifyUtils.formatMoney(s.price)}</span>\n      `);
        }
    }
    customElements.define("global-cart-upsell-thumb", GlobalCartUpsellThumb);

    //cart recommendations start
    class CartRecommendations extends HTMLElement {
        constructor() {
          super();
          this.ObserverLite = new ObserverLite();
          this.swiperInstance = null;
          this.resizeTimeout = null;
          this.handleResize = this.handleResize.bind(this);
        }
      
        subscribe(callback) {
          return this.ObserverLite.subscribe(callback);
        }
      
        next(value) {
          this.ObserverLite.next(value);
        }
      
        connectedCallback() {
          this.initializeSwiper();
          window.addEventListener('resize', this.handleResize);
          this.init();
        }

        async init() {
          this.GlobalCart = await new GlobalCart();
          this.forms = this.querySelectorAll('form');
          this.forms.forEach((form, i) => {
            form.addEventListener("submit", (e) => {
              e.preventDefault();
              this.GlobalCart.addViaForm(e.currentTarget);
              return false;
            });
          });
        }
        disconnectedCallback() {
          window.removeEventListener('resize', this.handleResize);
          if (this.swiperInstance) this.swiperInstance.destroy(true, true);
        }
      
        handleResize() {
          clearTimeout(this.resizeTimeout);
          this.resizeTimeout = setTimeout(() => {
            this.initializeSwiper();
          }, 250);
        }
      
        initializeSwiper() {
          const swiperEl = this.querySelector('.swiper');
          if (!swiperEl) return;
      
          if (this.swiperInstance) this.swiperInstance.destroy(true, true);
      
          const isMobile = window.innerWidth <= 991;
      
          // this.swiperInstance = new Swiper(swiperEl, {
          //   direction: isMobile ? 'horizontal' : 'vertical',
          //   slidesPerView: 'auto',
          //   spaceBetween: isMobile ? 15 : 20,
          //   freeMode: !isMobile,
          //   pagination: {
          //     el: this.querySelector('.swiper-pagination'),
          //     clickable: true,
          //     enabled: isMobile
          //   },
          //   breakpoints: isMobile
          //     ? {
          //         320: { slidesPerView: 1.2, spaceBetween: 10 },
          //         480: { slidesPerView: 1.5, spaceBetween: 15 },
          //         640: { slidesPerView: 2, spaceBetween: 20 },
          //       }
          //     : {},
          // });

          //hhehe
          // this.swiperInstance = new Swiper('.cart_recommendations-container .swiper', {
          //     direction: isMobile ? 'horizontal' : 'vertical',
          //     slidesPerView: isMobile ? 'auto' : 'auto',
          //     spaceBetween: isMobile ? 15 : 20,
          //     freeMode: !isMobile,
          //     pagination: {
          //         el: '.swiper-pagination',
          //         clickable: true,
          //         enabled: isMobile
          //     },
          //     breakpoints: isMobile ? {
          //         320: {
          //             slidesPerView: 1,
          //             spaceBetween: 10,
          //         },
          //         480: {
          //             slidesPerView: 1,
          //             spaceBetween: 15,
          //         },
          //         640: {
          //             slidesPerView: 2,
          //             spaceBetween: 20,
          //         }
          //     } : {}
          // });
          
        }
      
        async refresh() {
          try {
            const sectionId = 'cart-recommendation';
            const response = await fetch(`/?section_id=${sectionId}`);
            const html = await response.text();
        
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
        
            const newSection = tempDiv.querySelector(`#shopify-section-${sectionId}`);
            if (!newSection) return;
        
            const newContent = newSection.querySelector('.cart-recoms-data');
            const oldContent = document.querySelector('.cart-recoms-data');
            if (!newContent || !oldContent) return;
        
            oldContent.innerHTML = newContent.innerHTML; 
        
          } catch (err) {
            console.error('CartRecommendations refresh failed:', err);
          }
        }
    }
    
    customElements.define('cart-recommendations', CartRecommendations);

    //cart recommendation end
    class GlobalAppToggle extends HTMLElement {
        constructor() {
            super(),
                (this.ObserverLite = new ObserverLite()),
                (this.heading = this.attributes.heading.value),
                (this.content = this.attributes.content.value),
                (this.selected = window.localStorage.getItem("gvtAppToggle1610")),
                (this.selected = "true" == this.selected || null == this.selected);
        }
        subscribe(e) {
            return this.ObserverLite.subscribe(e);
        }
        next(e) {
            this.ObserverLite.next(e);
        }
        connectedCallback() {
            let e = `<div class="flex row-wrap align-center justify-space row">\n                       <h2 data-selected="${
                this.selected
            }"\n                           class="js-app-toggle-heading app-toggle__heading h-style f-w700 lh-r">${
                this.heading
            }</h2>\n                       <label class="option-checktoggle app-toggle__toggle">\n                         <input class="js-app-toggle-input option-checktoggle__input" \n                                name="app-subcribe"\n                                type="checkbox" \n                                ${
                this.selected ? "checked" : ""
            }>\n                         <div class="option-checktoggle__control"></div>\n                       </label>\n                      </div>\n                      <div class="t-s lh-r t-grey">${this.content}</div>`;
            (e = s(e)),
                (this.heading = e.querySelector(".js-app-toggle-heading")),
                (this.input = e.querySelector(".js-app-toggle-input")),
                this.appendChild(e),
                this.input.addEventListener("change", (e) => {
                    (this.selected = !this.selected),
                        (this.heading.dataset.selected = this.selected),
                        window.localStorage.setItem("gvtAppToggle", this.selected),
                        this.next(),
                        Array.from(document.querySelectorAll("global-app-toggle"))
                            .filter((e) => e != this)
                            .forEach((e) => {
                                e.input.dispatchEvent(new CustomEvent("changeSibling"));
                            });
                }),
                this.input.addEventListener("changeSibling", (e) => {
                    (this.selected = !this.selected), (this.input.checked = this.selected), (this.heading.dataset.selected = this.selected);
                });
        }
    }
    customElements.define("global-app-toggle", GlobalAppToggle);
    class GlobalSidebar extends HTMLElement {
        constructor() {
            super(), (this.ObserverLite = new ObserverLite());
        }
        subscribe(e) {
            return this.ObserverLite.subscribe(e);
        }
        next(e) {
            this.ObserverLite.next(e);
        }
        connectedCallback() {
            (this.content = this.querySelector("template").cloneNode(!0).content), (this.right = !!this.attributes.right);
        }
        open() {
            if (!this.wrapper) {
                let e =
                    '<div class="modal-wrapper">\n                         <div class="modal-mask modal-close"></div>\n                         <div class="modal-sidebar">\n                           <button aria-label="close" class="modal-close modal-close-btn modal-sidebar__close-btn btn-reset"></button>\n                         </div>\n                       </div>';
                (e = s(e)),
                    (this.wrapper = e.querySelector(".modal-wrapper")),
                    (this.wrapper.style.opacity = 0),
                    (this.mask = e.querySelector(".modal-mask")),
                    (this.contentWrapper = e.querySelector(".modal-sidebar")),
                    (this.contentWrapper.style.opacity = 0),
                    (this.closeButton = e.querySelector(".modal-close-btn")),
                    this.right ? ((this.contentWrapper.style.left = "auto"), (this.contentWrapper.style.right = "0px")) : ((this.closeButton.style.right = "0px"), (this.closeButton.style.left = "auto")),
                    this.contentWrapper.appendChild(this.content),
                    e.querySelectorAll(".modal-close").forEach((e) => {
                        e.addEventListener("click", (e) => {
                            e.preventDefault(), this.close();
                        });
                    }),
                    this.appendChild(e);
            }
            window.innerWidth, document.body.clientWidth;
            document.body.classList.add("body-masked"),
                (this.wrapper.style.display = "block"),
                (this.wrapper.animate([{ opacity: 0 }, { opacity: 1 }], 300).onfinish = (e) => {
                    e.target.effect.target.style.opacity = 1;
                });
            const e = this.right ? "150px" : "-150px";
            this.contentWrapper.animate(
                [
                    { transform: `translateX(${e})`, opacity: 0 },
                    { transform: "translateX(0px)", opacity: 1 },
                ],
                200
            ).onfinish = (e) => {
                (e.target.effect.target.style.transform = "translateX(0px)"), (e.target.effect.target.style.opacity = 1), this.next({ open: !0 });
            };
        }
        close() {
            this.classList.remove('show_recommendations'),
            (this.wrapper.animate([{ opacity: 1 }, { opacity: 0 }], 200).onfinish = (e) => {
                (e.target.effect.target.style.opacity = 0), (e.target.effect.target.style.display = "none"), document.body.classList.remove("body-masked"), this.next({ open: !1 });
            }),
                (this.contentWrapper.animate(
                    [
                        { transform: "scale(1)", opacity: 1 },
                        { transform: "scale(1.2)", opacity: 0 },
                    ],
                    200
                ).onfinish = (e) => {
                    e.target.effect.target.style.opacity = 0;
                });
        }
    }
    customElements.define("global-sidebar", GlobalSidebar);
    class GlobalSidebarCart extends HTMLElement {
        constructor() {
            super(), (this.cartFetchUrl = "/cart?view=ajax-sidebar-cart"), (this.loadingClass = "wbsk-ui__loading"), (this.ObserverLite = new ObserverLite()), (this.CartRecommendations = this.querySelector('cart-recommendations'));
        }
        subscribe(e) {
            return this.ObserverLite.subscribe(e);
        }
        next(e) {
            this.ObserverLite.next(e);
        }
        connectedCallback() {
            this.init();
        }
        async init() {
            (this.sidebar = this.querySelector("global-sidebar")),
                (this.GlobalCart = await new GlobalCart()),
                this.GlobalCart.subscribe(({ eventType: e }) => {
                    "update" == e && this.update();
                }),
                this.sidebar.subscribe(() => {
                    (this.cartTemplate = this.querySelector(".js-wbsk-sidebar-cart__cart-template")), (this.loadingClassElement = this.querySelector(".js-wbsk-sidebar-cart-container")), this.update();
                });
        }
        toggle() {
            this.sidebar.open();
            setTimeout(() => {
              this.sidebar.classList.add('show_recommendations');
            }, 300);
        }
        bind() {
            (this.qtyCtrl = this.querySelector(".js-wbsk-sidebar-cart__item-qty")),
                (this.actions = this.querySelector(".js-wbsk-sidebar-cart__actions")),
                (this.empty = this.querySelector(".js-wbsk-sidebar-cart__empty")),
                this.querySelectorAll(".js-wbsk-sidebar-cart__remove").forEach((e) =>
                    e.addEventListener("click", (e) => {
                        e.preventDefault(), this.removeItem(event.currentTarget.href);
                    })
                ),
                this.querySelectorAll(".js-wbsk-sidebar-cart__item-qty").forEach((e) =>
                    e.addEventListener("change", (e) => {
                        this.updateQty({ key: e.currentTarget.dataset.id, qty: e.currentTarget.value });
                    })
                );
        }
        addToCart(e, t) {
            (t = t || this.GlobalCart.serialize(e)), this.GlobalCart.addToCart(t);
        }
        update() {
            return (
                (this.isInit = !0),
                new Promise((e, t) => {
                    this.loadingClass && this.loadingClassElement && this.loadingClassElement.classList.add(this.loadingClass),
                        fetch(this.cartFetchUrl)
                            .then((e) => e.text())
                            .then((e) => {
                                (this.cartTemplate.innerHTML = e), this.loadingClass && this.loadingClassElement && this.loadingClassElement.classList.remove(this.loadingClass), this.bind(), this.CartRecommendations?.refresh() ;
                            });
                })
            );
        }
        updateQty({ key: e, qty: t }) {
            this.loadingClass && this.loadingClassElement && this.loadingClassElement.classList.add(this.loadingClass), this.GlobalCart.updateQty({ key: e }, t);
        }
        removeItem(e) {
            this.loadingClass && this.loadingClassElement && this.loadingClassElement.classList.add(this.loadingClass), this.GlobalCart.removeItem(e);
        }
    }
    customElements.define("global-sidebar-cart", GlobalSidebarCart);
    class GlobalOptionSelector extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            if (this.id) return !1;
            (this.id = Math.floor(999999999999999 * Math.random())),
                (this.ObserverLite = new ObserverLite()),
                (this.option = !!this.attributes.option && JSON.parse(this.attributes.option.value)),
                (this.multiple = !!this.attributes.multiple),
                (this.hasAllOption = this.multiple && this.option.values.indexOf("All") > -1),
                this.render();
        }
        subscribe(e) {
            return this.ObserverLite.subscribe(e);
        }
        next(e) {
            this.ObserverLite.next(e);
        }
        render() {
            (this.innerHTML = this.getOptionsHtml()), this.bind();
        }
        getOptionsHtml() {
            let { name: e, values: t, selected: s } = this.option;
            return `<div class="flex-grid--d2 flex row-wrap align-center justify-left">${t
                .map(
                    (t) =>
                        `<div class="block-rel d-block">\n               <input class="js-selector-radio option-radio__input" \n                      value='${t}' \n                      type="${
                            this.multiple ? "checkbox" : "radio"
                        }"  \n                      name='${this.id}-${e}'  \n                      ${
                            (!this.multiple && t == s) || (this.multiple && s.indexOf(t) >= 0) ? "checked" : ""
                        }>\n               <span class="option-radio__control btn-reset">${t}</span> \n               </div>`
                )
                .join("")}</div>`;
        }
        updateValues() {
            if (
                (this.querySelectorAll("input").forEach((e) => {
                    let { name: t, value: s, checked: i } = e;
                    if (!this.multiple && i) this.option.selected = s;
                    else if (this.multiple) {
                        const e = this.option.selected.findIndex((e) => e == s);
                        !i && e >= 0 ? this.option.selected.splice(e, 1) : i && e < 0 && this.option.selected.push(s);
                    }
                }),
                this.multiple && this.hasAllOption)
            ) {
                const e = this.querySelector('input[value="All"]');
                0 == this.option.selected.length
                    ? ((e.checked = !0), this.option.selected.push("All"))
                    : this.option.selected.filter((e) => "All" == e).length && this.option.selected.indexOf("All") != this.option.selected.length - 1
                    ? ((e.checked = !1), this.option.selected.splice(this.option.selected.indexOf("All"), 1))
                    : this.option.selected.indexOf("All") == this.option.selected.length - 1 &&
                      ((this.option.selected = ["All"]),
                      this.querySelectorAll("input").forEach((e) => {
                          e.checked = "All" == e.value;
                      }));
            }
            this.next();
        }
        bind(e) {
            (e = e || this).querySelectorAll("input").forEach((e) =>
                e.addEventListener("change", (e) => {
                    this.updateValues();
                })
            );
        }
    }
    customElements.define("global-option-selector", GlobalOptionSelector);
    class GlobalGloblisationToggle extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.id = Math.floor(999999999999999 * Math.random());
        }
        render(e) {
            this.innerHTML = `<button class="js-ter-toggle btn-reset wbsk-ui-ter-selector-item wbsk-ui-ter-toggle"  \n                              style="background-image:url('${e.icon}');"></button>`;
        }
    }
    customElements.define("global-globalisation-toggle", GlobalGloblisationToggle);
    class GlobalGloblisationForm extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            (this.helper = !!this.attributes.helper && JSON.parse(this.attributes.helper.value)), this.render();
        }
        addParamsToRedirectURL(e) {
            return new Promise(async (t, s) => {
                e = e.includes("?") ? e : `${e}?`;
                const r = i(window.location);
                if ((delete r.relocate, document.referrer && !r.referrer)) {
                    const t = "referrer=" + encodeURIComponent(document.referrer);
                    e = e + "&" + t;
                }
                Object.keys(r).length &&
                    (e =
                        e +
                        "&" +
                        Object.keys(r)
                            .map((e) => {
                                if (e.length && r[e] && r[e].length && null != r[e] && "undefined" != r[e]) return `${e}=${r[e]}`;
                            })
                            .join("&"));
                const a = await this.getGaParams();
                a && (e = `${e}&${a}`), t(e);
            });
        }
        getGaParams() {
            return new Promise((e, t) => {
                let s = !1;
                const i = setTimeout(() => {
                    s || (e(!1), (s = !0));
                }, 500);
                if ("undefined" != typeof ga)
                    try {
                        ga((t) => {
                            try {
                                clearTimeout(i);
                                const r = t.get("linkerParam");
                                r ? (e(r), (s = !0)) : (e(!1), (s = !0));
                            } catch (t) {
                                s || (e(!1), (s = !0));
                            }
                        });
                    } catch (t) {
                        s || (e(!1), (s = !0));
                    }
                else s || (e(!1), (s = !0));
            });
        }
        redirect(e) {
            this.addParamsToRedirectURL(`${e}?relocate=true`).then((e) => {
                window.location.href = e;
            });
        }
        bind() {
            this.querySelectorAll(".js-ter-control").forEach((e) =>
                e.addEventListener("click", (e) => {
                    const t = e.target.dataset.ter,
                        s = e.target.dataset.url;
                    t != this.helper.active.title && this.redirect(s);
                })
            );
        }
        render() {
            (this.innerHTML = `<div class="wbsk-ui-ter-selector-modal">\n                        <h2 class="h-style h-accent t-m row">${
                this.helper.default.box_heading
            }</h2>\n                        <div class="wbsk-ui-ter-selector-modal__items">\n                        ${this.helper.territories
                .map(
                    ({ icon: e, title: t, long_title: s, url: i }) =>
                        `<button class="js-ter-control btn-reset wbsk-ui-ter-selector-item ${
                            t == this.helper.active.title ? "wbsk-ui-ter-selector-item--btn-active" : ""
                        }" \n                                          data-ter="${t}" \n                                          data-url="${i}" \n                                          style="background-image:url('${e}');">${s}</button>`
                )
                .join("")}\n                       </div>`),
                this.bind();
        }
    }
    customElements.define("global-globalisation-form", GlobalGloblisationForm);
    class ProductOptionSelector extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            if (this.id) return !1;
            if (
                ((this.id = Math.floor(999999999999999 * Math.random())),
                (this.ObserverLite = new ObserverLite()),
                (this.options = !!this.attributes.options && JSON.parse(this.attributes.options.value)),
                (this.variants = !!this.attributes.variants && JSON.parse(this.attributes.variants.value)),
                this.options)
            ) {
                const e = this.attributes.selectedOptions ? JSON.parse(this.attributes.selectedOptions.value) : this.options.map(({ values: e }) => e[0]);
                (this.options = this.options.map((t, s) => ((t.selected = e[s]), t))), this.updateAvailableOptions(0);
            }
        }
        subscribe(e) {
            return this.ObserverLite.subscribe(e);
        }
        next(e) {
            this.ObserverLite.next(e);
        }
        get selectedOptions() {
            return this.options.map(({ selected: e }) => e);
        }
        get selectedVariant() {
            if (this.variants) {
                const e = this.variants.filter((e) => e.options.join(",") == this.selectedOptions.join(","));
                return !!e.length && e[0];
            }
            return !1;
        }
        updateAvailableOptions(e, t) {
            this.options = this.options.map((e, t) => {
                e.selected;
                return (
                    this.variants &&
                        ((e.values = []),
                        this.variants.forEach(({ options: s }) => {
                            const i = JSON.parse(JSON.stringify(s)),
                                r = this.selectedOptions;
                            r.length = t;
                            for (let [e, s] of r.entries())
                                if (s != i[e]) {
                                    i[t] = !1;
                                    break;
                                }
                            i[t] && e.values.push(i[t]);
                        })),
                    (e.values = [...new Set(e.values)]),
                    (e.selected = !e.selected || (e.selected && e.values.indexOf(e.selected) < 0) ? e.values[0] : e.selected),
                    e
                );
            });
            const s = new Array(this.options.length).fill(!1).map((t, s) => s >= e);
            this.render(s), t || this.next();
        }
        htmlToNode(e) {
            var t = document.createElement("template");
            return (e = e.trim()), (t.innerHTML = e), t.content.firstChild;
        }
        render(e) {
            const t = e.filter((e) => e).length;
            if (t == this.options.length) {
                let e = this.options
                    .map(
                        (e) =>
                            `<label class="d-block t-s f-w500 row--d2">${e.name}</label>\n                          <global-option-selector option='${JSON.stringify(e)}' \n                                                  class="${
                                this.itemWrapperClass
                            }" \n                                                  data-virtual="${e.virtual}" \n                                                  data-name="${e.name}"></global-option-selector>`
                    )
                    .filter((e) => e);
                e && (this.innerHTML = e.join("")), (this.options = this.options.map((e) => ((e.element = this.querySelector(`[data-name="${e.name}"]`)), this.bind(e.element), e)));
            } else
                this.options.forEach((t, s) => {
                    let i = this.querySelector(`[data-name="${t.name}"]`);
                    if (e[s]) {
                        const e = this.htmlToNode(
                            `<global-option-selector option='${JSON.stringify(t)}' \n                                                                   class="${
                                this.itemWrapperClass
                            }" \n                                                                   data-virtual="${t.virtual}" \n                                                                   data-name="${
                                t.name
                            }"></global-option-selector>`
                        );
                        i.replaceWith(e), (this.options[s].element = i = this.querySelector(`[data-name="${t.name}"]`)), this.bind(i);
                    }
                });
        }
        bind(e) {
            e.subscribe(() => {
                let { name: t, selected: s } = e.option;
                const i = this.options.findIndex((e) => e.name == t);
                (this.options[i].selected = s), this.updateAvailableOptions(i + 1);
            });
        }
    }
    customElements.get("product-option-selector") || customElements.define("product-option-selector", ProductOptionSelector);
    class GlobalSearchForm extends HTMLElement {
        constructor() {
            super(), (this.ObserverLite = new ObserverLite()), (this.ShopifyUtils = new ShopifyUtils());
        }
        subscribe(e) {
            return this.ObserverLite.subscribe(e);
        }
        next(e) {
            this.ObserverLite.next(e);
        }
        connectedCallback() {
            (this.translations = !!this.attributes.translations && JSON.parse(this.attributes.translations.value)), this.render();
        }
        render() {
            (this.innerHTML = `<div class="wbsk-ui-scroll-flex">\n                          <div class="search-form__input-wrapper wbsk-ui-scroll-flex__fixed">\n                            <input class="js-input reset-input search-form__input" placeholder="${this.translations.input_placeholder}">\n                          </div>\n                          <div class="js-results-wrapper wbsk-ui-scroll-flex__scroll"></div>\n                        </div>`),
                (this.resultsWrapper = this.querySelector(".js-results-wrapper")),
                (this.input = this.querySelector(".js-input")),
                this.input.addEventListener("keyup", () => {
                    this.onTermsChange();
                }),
                this.input.focus(),
                this.onTermsChange();
        }
        onTermsChange() {
            this.input.value.length >= 1 ? this.updateResults() : (this.resultsWrapper.innerHTML = `<div class="placeholder-products">${this.dataset.resultsPlaceholder}</div>`);
        }
        updateResults() {
            fetch(`/search/suggest.json?q=${this.input.value}&resources[type]=product&resources[options]&resources[options][fields]=title,product_type,variants.title`)
                .then((e) => e.json())
                .then(({ resources: e }) => {
                    const { products: t } = e.results;
                    if (t.length) {
                        const e = t.map(
                            (e) =>
                                `<a href="${
                                    e.url
                                }"\n                         class="search-form-list__item flex row-wrap align-center justify-left">\n                         <img class="search-form-list__item-image"\n                              width="100"\n                              height="100"\n                              src="${
                                    e.image
                                }?width=100">\n                              <div class="search-form-list__content">\n                              <span class="d-block t-s lh-l">${
                                    e.title
                                }</span>\n                              <span class="d-block t-xs row f-w500">${this.ShopifyUtils.formatMoney(
                                    e.price
                                )}</span>\n                              </div>\n                      </a>\n                      `
                        );
                        this.resultsWrapper.innerHTML = e;
                    } else this.resultsWrapper.innerHTML = `<p class="ct--x3 cb--x3 cell-l cell-r tac">${this.translations.empty}</p>`;
                });
        }
    }
    customElements.define("global-search-form", GlobalSearchForm);
    class GlobalProductThumbnail extends HTMLElement {
        constructor() {
            super(), (this.ShopifyUtils = new ShopifyUtils());
        }
        connectedCallback() {
            r().then(() => {
                const e = this.querySelector("template");
                if (e) {
                    try {
                        (this.settings = JSON.parse(e.innerHTML)), e.remove();
                    } catch (e) {
                        console.log(e);
                    }
                    if (((this.variant = this.settings?.variant || !1), (this.translations = this.settings?.translations || !1), (this.selected_variant = this.settings?.selected_variant || !1), this.init)) return;
                    this.addEventListener("mouseover", () => {
                        this.init ||
                            r()
                                .then(() => {
                                    this.build();
                                })
                                .catch((e) => {
                                    console.log(e);
                                });
                    });
                }
            });
        }
        build() {
            this.init = !0;
            const e = this.querySelector("template"),
                t = s(e.innerHTML);
            e.parentNode.replaceChild(t, e),
                (this.productForm = this.querySelector(".js-form")),
                (this.cart = document.querySelector("global-sidebar-cart")),
                (this.productSelectors = this.querySelector(".js-option-selectors")),
                (this.productSelectedVariantId = this.querySelector(".js-variant_id")),
                (this.productPrice = this.querySelector(".js-price")),
                (this.productATC = this.querySelector(".js-atc")),
                this.productSelectors &&
                    (this.productSelectors.subscribe(() => {
                        this.onProductVariantChange(this.productSelectors.selectedVariant);
                    }),
                    this.onProductVariantChange(this.variant)),
                this.productForm.addEventListener("submit", (e) => (e.stopPropagation(), e.preventDefault(), this.cart.toggle(), this.cart.addToCart(this.productForm), !1));
        }
        onProductVariantChange(e) {
          var gridVariantData = this.querySelector(".grid-variant-json");
          var gridVariantData = JSON.parse(gridVariantData.textContent);
    
          var cur_id = e.id;
          var matchingVar = gridVariantData.metafields.find(function (variant) {
            return variant.id == cur_id;
          });
            var discount_priceDiv =  this.querySelector(".discount_price_colle");
        
            if(discount_priceDiv){
              if (e.compare_at_price > e.price) {
              var price = e.price;
              var Cprice = e.compare_at_price;
              var discount_price =  Cprice - price;
                discount_priceDiv.innerHTML = "Save " + (this.ShopifyUtils.formatMoney(discount_price));
                discount_priceDiv.style.display = 'block';
              } else {
                discount_priceDiv.style.display = 'none';
              }
            }
            this.productSelectedVariantId.value = e.id;
            const t = e.compare_at_price && e.compare_at_price != e.price;
            (this.productPrice.innerHTML = `<span class="${t ? "t-red" : ""}">\n                                   ${this.ShopifyUtils.formatMoney(e.price)}\n                                   </span>\n                                   ${
                t ? `<span class="t-r cell-l--d3 d-block"><strike>${this.ShopifyUtils.formatMoney(e.compare_at_price)}</strike></span>` : ""
            }`),
                (this.productATC.disabled = !e.available),
                (this.productATC.innerHTML = e.available
            ? matchingVar.status != ""
              ? matchingVar.status
              : this.translations.add_to_cart
            : this.translations.sold_out);
        }
    }
    function le(e) {
        const t = document.querySelector(`.js-content-gallery--${e.id}`),
            s = {
                slidesPerView: 1,
                navigation: { nextEl: `.js-slider-nav--next--${e.id}`, prevEl: `.js-slider-nav--prev--${e.id}` },
                scrollbar: { el: `.js-content-gallery--${e.id}__scrollbar`, draggable: !0 },
                spaceBetween: window.globalDesign.gutterUnit.desktop,
                breakpoints: { 737: { slidesPerView: 3, spaceBetween: window.globalDesign.gutterUnit.mobile }, 1024: { slidesPerView: 4 } },
                injectStyles: ["\n        :host .swiper-wrapper {\n          align-items: stretch;\n        }\n        :host swiper-slide.swiper-slide--auto-height{\n          height:auto;\n        }\n      "],
                modules: [ne, ie],
            };
        Object.assign(t, s), t.initialize();
    }
    function oe(e) {
        const t = document.querySelector(`.js-instagram-gallery--${e.id}`),
            s = { slidesPerView: 3.5, spaceBetween: window.globalDesign.gutterUnit.mobile, breakpoints: { 737: { slidesPerView: 4.5, spaceBetween: window.globalDesign.gutterUnit.desktop }, 1024: { slidesPerView: 5.5 } } };
        Object.assign(t, s), t.initialize();
    }
    function ce(e, t = {}) {
        const { extra_properties: s = {} } = t;
        s.$source = s.$source || "$embed";
        Array.from(document.querySelectorAll(e)).forEach((e) => {
            const i = e.dataset.ajaxSubmit || "//manage.kmail-lists.com/ajax/subscriptions/subscribe";
            e.addEventListener("submit", async function (r) {
                r.preventDefault();
                const a = de(new FormData(e), s),
                    n = e.querySelector(".klaviyo_submit_button");
                n && n.setAttribute("disabled", !0);
                try {
                    const s = await fetch(i, { method: "POST", body: a }),
                        r = await s.json();
                    console.log(r);
                    const n = e.querySelector(".success_message") || e.parentElement.querySelector(".success_message"),
                        l = e.querySelector(".error_message") || e.parentElement.querySelector(".error_message");
                    if ((n && (n.style.display = "none"), l && (l.style.display = "none"), r.success))
                        if ((window._learnq && _learnq.push && (_learnq.push(["identify", { $email: r.data }]), _learnq.push(["trackActivity"])), t.success_url)) window.location = t.success_url;
                        else {
                            if (
                                (n &&
                                    ((n.style.display = "block"),
                                    (n.innerHTML = t?.custom_success_message || '<div class="klaviyo_header">Thanks for subscribing!</div><div class="klaviyo_subheader">Check your email for a confirmation message.</div>')),
                                !0 === t.hide_form_on_success && (e.querySelectorAll(".klaviyo_field_group input, .klaviyo_form_actions").forEach((e) => (e.style.display = "none")), e.classList.contains("klaviyo_horizontal_form")))
                            ) {
                                const t = e.querySelector(".klaviyo_field_group");
                                t && (t.style.display = "none");
                            }
                            t.success && t.success(e, r.data), e.dispatchEvent(new Event("klaviyo.subscribe.success")), e.reset();
                        }
                    else {
                        const t = e.querySelector(".error_message");
                        t && ((t.style.display = "block"), (t.innerHTML = r.errors.join(" "))), e.dispatchEvent(new Event("klaviyo.subscribe.error"));
                    }
                } catch (e) {
                    console.log(e), console.warn("Something went wrong.", e);
                }
            });
        });
    }
    customElements.get("global-product-thumbnail") || customElements.define("global-product-thumbnail", GlobalProductThumbnail);
    const de = (e, t) => {
        e.append("$timezone_offset", new Date().getTimezoneOffset() / -60),
            Object.entries(t).forEach(([t, s]) => {
                e.append(t, s);
            });
        const s = Array.from(e.keys()).concat(Object.keys(t));
        if (e.has("$fields")) {
            const t = e.get("$fields");
            e.set("$fields", t + "," + s.join(","));
        } else e.append("$fields", s.join(","));
        return e;
    };
    const pe = [
        "eventsPrefix",
        "injectStyles",
        "injectStylesUrls",
        "modules",
        "init",
        "_direction",
        "oneWayMovement",
        "touchEventsTarget",
        "initialSlide",
        "_speed",
        "cssMode",
        "updateOnWindowResize",
        "resizeObserver",
        "nested",
        "focusableElements",
        "_enabled",
        "_width",
        "_height",
        "preventInteractionOnTransition",
        "userAgent",
        "url",
        "_edgeSwipeDetection",
        "_edgeSwipeThreshold",
        "_freeMode",
        "_autoHeight",
        "setWrapperSize",
        "virtualTranslate",
        "_effect",
        "breakpoints",
        "_spaceBetween",
        "_slidesPerView",
        "maxBackfaceHiddenSlides",
        "_grid",
        "_slidesPerGroup",
        "_slidesPerGroupSkip",
        "_slidesPerGroupAuto",
        "_centeredSlides",
        "_centeredSlidesBounds",
        "_slidesOffsetBefore",
        "_slidesOffsetAfter",
        "normalizeSlideIndex",
        "_centerInsufficientSlides",
        "_watchOverflow",
        "roundLengths",
        "touchRatio",
        "touchAngle",
        "simulateTouch",
        "_shortSwipes",
        "_longSwipes",
        "longSwipesRatio",
        "longSwipesMs",
        "_followFinger",
        "allowTouchMove",
        "_threshold",
        "touchMoveStopPropagation",
        "touchStartPreventDefault",
        "touchStartForcePreventDefault",
        "touchReleaseOnEdges",
        "uniqueNavElements",
        "_resistance",
        "_resistanceRatio",
        "_watchSlidesProgress",
        "_grabCursor",
        "preventClicks",
        "preventClicksPropagation",
        "_slideToClickedSlide",
        "_loop",
        "loopedSlides",
        "loopPreventsSliding",
        "_rewind",
        "_allowSlidePrev",
        "_allowSlideNext",
        "_swipeHandler",
        "_noSwiping",
        "noSwipingClass",
        "noSwipingSelector",
        "passiveListeners",
        "containerModifierClass",
        "slideClass",
        "slideActiveClass",
        "slideVisibleClass",
        "slideNextClass",
        "slidePrevClass",
        "wrapperClass",
        "lazyPreloaderClass",
        "lazyPreloadPrevNext",
        "runCallbacksOnInit",
        "observer",
        "observeParents",
        "observeSlideChildren",
        "a11y",
        "_autoplay",
        "_controller",
        "coverflowEffect",
        "cubeEffect",
        "fadeEffect",
        "flipEffect",
        "creativeEffect",
        "cardsEffect",
        "hashNavigation",
        "history",
        "keyboard",
        "mousewheel",
        "_navigation",
        "_pagination",
        "parallax",
        "_scrollbar",
        "_thumbs",
        "virtual",
        "zoom",
        "control",
    ];
    function ue(e) {
        return "object" == typeof e && null !== e && e.constructor && "Object" === Object.prototype.toString.call(e).slice(8, -1);
    }
    function he(e, t) {
        const s = ["__proto__", "constructor", "prototype"];
        Object.keys(t)
            .filter((e) => s.indexOf(e) < 0)
            .forEach((s) => {
                void 0 === e[s] ? (e[s] = t[s]) : ue(t[s]) && ue(e[s]) && Object.keys(t[s]).length > 0 ? (t[s].__swiper__ ? (e[s] = t[s]) : he(e[s], t[s])) : (e[s] = t[s]);
            });
    }
    function me(e = "") {
        return e.replace(/-[a-z]/g, (e) => e.toUpperCase().replace("-", ""));
    }
    const ge = (e) => (parseFloat(e) === Number(e) ? Number(e) : "true" === e || "" === e || ("false" !== e && ("null" === e ? null : "undefined" !== e ? e : void 0))),
        fe = [
            "a11y",
            "autoplay",
            "controller",
            "cards-effect",
            "coverflow-effect",
            "creative-effect",
            "cube-effect",
            "fade-effect",
            "flip-effect",
            "free-mode",
            "grid",
            "hash-navigation",
            "history",
            "keyboard",
            "mousewheel",
            "navigation",
            "pagination",
            "parallax",
            "scrollbar",
            "thumbs",
            "virtual",
            "zoom",
        ];
    function be(e, t, s) {
        const i = {},
            r = {};
        he(i, J);
        const a = [...pe, "on"],
            n = a.map((e) => e.replace(/_/, ""));
        a.forEach((t) => {
            (t = t.replace("_", "")), void 0 !== e[t] && (r[t] = e[t]);
        });
        const l = [...e.attributes];
        return (
            "string" == typeof t && void 0 !== s && l.push({ name: t, value: s }),
            l.forEach((e) => {
                const t = fe.filter((t) => 0 === e.name.indexOf(`${t}-`))[0];
                if (t) {
                    const s = me(t),
                        i = me(e.name.split(`${t}-`)[1]);
                    void 0 === r[s] && (r[s] = {}), !0 === r[s] && (r[s] = { enabled: !0 }), (r[s][i] = ge(e.value));
                } else {
                    const t = me(e.name);
                    if (!n.includes(t)) return;
                    const s = ge(e.value);
                    r[t] && fe.includes(e.name) ? (r[t].constructor !== Object && (r[t] = {}), (r[t].enabled = s)) : (r[t] = s);
                }
            }),
            he(i, r),
            i.navigation ? (i.navigation = { prevEl: ".swiper-button-prev", nextEl: ".swiper-button-next", ...(!0 !== i.navigation ? i.navigation : {}) }) : !1 === i.navigation && delete i.navigation,
            i.scrollbar ? (i.scrollbar = { el: ".swiper-scrollbar", ...(!0 !== i.scrollbar ? i.scrollbar : {}) }) : !1 === i.scrollbar && delete i.scrollbar,
            i.pagination ? (i.pagination = { el: ".swiper-pagination", ...(!0 !== i.pagination ? i.pagination : {}) }) : !1 === i.pagination && delete i.pagination,
            { params: i, passedParams: r }
        );
    }
    const ve =
        "@font-face{font-family:swiper-icons;src:url('data:application/font-woff;charset=utf-8;base64, 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');font-weight:400;font-style:normal}";
    let we = !0;
    const ye = (e, t) => {
        let s = document.querySelector("style#swiper-element-styles");
        const i = s && s.preInit && !e;
        !e &&
            t &&
            t.cssLinks().forEach((e) => {
                const t = document.createElement("link");
                (t.rel = "stylesheet"), (t.href = e), document.head.prepend(t);
            }),
            (s && !i) || ((s = s || document.createElement("style")), (s.textContent = [ve, t ? t.cssStyles() : ""].join("\n")), (s.id = "swiper-element-styles"), (s.preInit = e), document.head.prepend(s));
    };
    const Se = "undefined" == typeof window || "undefined" == typeof HTMLElement ? class DummyHTMLElement {} : HTMLElement;
    class SwiperContainer extends Se {
        constructor() {
            super(), (this.tempDiv = document.createElement("div")), (this.shadowEl = this.attachShadow({ mode: "open" }));
        }
        cssStyles() {
            return [
                we
                    ? ":root{--swiper-theme-color:#007aff}.swiper,swiper-container{margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1;display:block}:host(.swiper-vertical)>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;transition-timing-function:var(--swiper-wrapper-transition-timing-function,initial);box-sizing:content-box}.swiper-android swiper-slide,.swiper-wrapper{transform:translate3d(0px,0,0)}.swiper-horizontal{touch-action:pan-y}.swiper-vertical{touch-action:pan-x}swiper-slide{flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform;display:block}.swiper-slide-invisible-blank{visibility:hidden}.swiper-autoheight,.swiper-autoheight swiper-slide{height:auto}:host(.swiper-autoheight) .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-backface-hidden swiper-slide{transform:translateZ(0);-webkit-backface-visibility:hidden;backface-visibility:hidden}:host(.swiper-3d.swiper-css-mode) .swiper-wrapper{perspective:1200px}:host(.swiper-3d) .swiper-wrapper{transform-style:preserve-3d}.swiper-3d{perspective:1200px}.swiper-3d .swiper-cube-shadow,.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top,.swiper-3d swiper-slide{transform-style:preserve-3d}.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}.swiper-3d .swiper-slide-shadow{background:rgba(0,0,0,.15)}.swiper-3d .swiper-slide-shadow-left{background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-right{background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-top{background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-3d .swiper-slide-shadow-bottom{background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}:host(.swiper-css-mode)>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}:host(.swiper-css-mode)>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-css-mode>swiper-slide{scroll-snap-align:start start}:host(.swiper-horizontal.swiper-css-mode)>.swiper-wrapper{scroll-snap-type:x mandatory}:host(.swiper-vertical.swiper-css-mode)>.swiper-wrapper{scroll-snap-type:y mandatory}:host(.swiper-css-mode.swiper-free-mode)>.swiper-wrapper{scroll-snap-type:none}.swiper-css-mode.swiper-free-mode>swiper-slide{scroll-snap-align:none}:host(.swiper-centered)>.swiper-wrapper::before{content:'';flex-shrink:0;order:9999}.swiper-centered>swiper-slide{scroll-snap-align:center center;scroll-snap-stop:always}.swiper-centered.swiper-horizontal>swiper-slide:first-child{margin-inline-start:var(--swiper-centered-offset-before)}:host(.swiper-centered.swiper-horizontal)>.swiper-wrapper::before{height:100%;min-height:1px;width:var(--swiper-centered-offset-after)}.swiper-centered.swiper-vertical>swiper-slide:first-child{margin-block-start:var(--swiper-centered-offset-before)}:host(.swiper-centered.swiper-vertical)>.swiper-wrapper::before{width:100%;min-width:1px;height:var(--swiper-centered-offset-after)}.swiper-lazy-preloader{width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;transform-origin:50%;box-sizing:border-box;border:4px solid var(--swiper-preloader-color,var(--swiper-theme-color));border-radius:50%;border-top-color:transparent}.swiper-watch-progress .swiper-slide-visible .swiper-lazy-preloader,.swiper:not(.swiper-watch-progress) .swiper-lazy-preloader,swiper-container:not(.swiper-watch-progress) .swiper-lazy-preloader{animation:swiper-preloader-spin 1s infinite linear}.swiper-lazy-preloader-white{--swiper-preloader-color:#fff}.swiper-lazy-preloader-black{--swiper-preloader-color:#000}@keyframes swiper-preloader-spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}"
                    : "",
                ...(this.injectStyles && Array.isArray(this.injectStyles) ? this.injectStyles : []),
            ].join("\n");
        }
        cssLinks() {
            return this.injectStylesUrls || [];
        }
        render() {
            if (this.rendered) return;
            we && ye(!1, this);
            const e = this.cssStyles();
            e.length && ((this.stylesEl = document.createElement("style")), (this.stylesEl.textContent = e), this.shadowEl.appendChild(this.stylesEl)),
                this.cssLinks().forEach((e) => {
                    if (this.shadowEl.querySelector(`link[href="${e}"]`)) return;
                    const t = document.createElement("link");
                    (t.rel = "stylesheet"), (t.href = e), this.shadowEl.appendChild(t);
                }),
                (this.tempDiv.innerHTML = `\n      <slot name="container-start"></slot>\n      <div class="swiper-wrapper">\n        <slot></slot>\n      </div>\n      <slot name="container-end"></slot>\n      ${
                    (function (e = {}) {
                        return e.navigation && void 0 === e.navigation.nextEl && void 0 === e.navigation.prevEl;
                    })(this.passedParams)
                        ? '\n        <div part="button-prev" class="swiper-button-prev"></div>\n        <div part="button-next" class="swiper-button-next"></div>\n      '
                        : ""
                }\n      ${
                    (function (e = {}) {
                        return e.pagination && void 0 === e.pagination.el;
                    })(this.passedParams)
                        ? '\n        <div part="pagination" class="swiper-pagination"></div>\n      '
                        : ""
                }\n      ${
                    (function (e = {}) {
                        return e.scrollbar && void 0 === e.scrollbar.el;
                    })(this.passedParams)
                        ? '\n        <div part="scrollbar" class="swiper-scrollbar"></div>\n      '
                        : ""
                }\n    `),
                [...this.tempDiv.children].forEach((e) => {
                    this.shadowEl.appendChild(e);
                }),
                (this.rendered = !0);
        }
        initialize() {
            if (this.initialized) return;
            this.initialized = !0;
            const { params: e, passedParams: t } = be(this);
            (this.swiperParams = e),
                (this.passedParams = t),
                delete this.swiperParams.init,
                this.render(),
                (this.swiper = new te(this, {
                    ...e,
                    touchEventsTarget: "container",
                    ...(e.virtual ? {} : { observer: !0 }),
                    onAny: (t, ...s) => {
                        const i = e.eventsPrefix ? `${e.eventsPrefix}${t.toLowerCase()}` : t.toLowerCase(),
                            r = new CustomEvent(i, { detail: s, bubbles: !0, cancelable: !0 });
                        this.dispatchEvent(r);
                    },
                }));
        }
        connectedCallback() {
            (this.initialized && this.nested && this.closest("swiper-slide") && this.closest("swiper-slide").swiperLoopMoveDOM) || (!1 !== this.init && "false" !== this.getAttribute("init") ? this.initialize() : ye(!0, this));
        }
        disconnectedCallback() {
            (this.nested && this.closest("swiper-slide") && this.closest("swiper-slide").swiperLoopMoveDOM) || (this.swiper && this.swiper.destroy && this.swiper.destroy(), (this.initialized = !1));
        }
        updateSwiperOnPropChange(e, t) {
            const { params: s, passedParams: i } = be(this, e, t);
            (this.passedParams = i),
                (this.swiperParams = s),
                (function ({ swiper: e, slides: t, passedParams: s, changedParams: i, nextEl: r, prevEl: a, scrollbarEl: n, paginationEl: l }) {
                    const o = i.filter((e) => "children" !== e && "direction" !== e && "wrapperClass" !== e),
                        { params: c, pagination: d, navigation: p, scrollbar: u, virtual: h, thumbs: m } = e;
                    let g, f, b, v, w, y, S, A;
                    i.includes("thumbs") && s.thumbs && s.thumbs.swiper && c.thumbs && !c.thumbs.swiper && (g = !0),
                        i.includes("controller") && s.controller && s.controller.control && c.controller && !c.controller.control && (f = !0),
                        i.includes("pagination") && s.pagination && (s.pagination.el || l) && (c.pagination || !1 === c.pagination) && d && !d.el && (b = !0),
                        i.includes("scrollbar") && s.scrollbar && (s.scrollbar.el || n) && (c.scrollbar || !1 === c.scrollbar) && u && !u.el && (v = !0),
                        i.includes("navigation") && s.navigation && (s.navigation.prevEl || a) && (s.navigation.nextEl || r) && (c.navigation || !1 === c.navigation) && p && !p.prevEl && !p.nextEl && (w = !0);
                    const E = (t) => {
                        e[t] &&
                            (e[t].destroy(),
                            "navigation" === t
                                ? (e.isElement && (e[t].prevEl.remove(), e[t].nextEl.remove()), (c[t].prevEl = void 0), (c[t].nextEl = void 0), (e[t].prevEl = void 0), (e[t].nextEl = void 0))
                                : (e.isElement && e[t].el.remove(), (c[t].el = void 0), (e[t].el = void 0)));
                    };
                    i.includes("loop") && e.isElement && (c.loop && !s.loop ? (y = !0) : !c.loop && s.loop ? (S = !0) : (A = !0)),
                        o.forEach((e) => {
                            if (ue(c[e]) && ue(s[e])) he(c[e], s[e]), ("navigation" !== e && "pagination" !== e && "scrollbar" !== e) || !("enabled" in s[e]) || s[e].enabled || E(e);
                            else {
                                const t = s[e];
                                (!0 !== t && !1 !== t) || ("navigation" !== e && "pagination" !== e && "scrollbar" !== e) ? (c[e] = s[e]) : !1 === t && E(e);
                            }
                        }),
                        o.includes("controller") && !f && e.controller && e.controller.control && c.controller && c.controller.control && (e.controller.control = c.controller.control),
                        i.includes("children") && t && h && c.virtual.enabled && ((h.slides = t), h.update(!0)),
                        i.includes("children") && t && c.loop && (A = !0),
                        g && m.init() && m.update(!0);
                    f && (e.controller.control = c.controller.control),
                        b &&
                            (!e.isElement || (l && "string" != typeof l) || ((l = document.createElement("div")).classList.add("swiper-pagination"), e.el.shadowEl.appendChild(l)),
                            l && (c.pagination.el = l),
                            d.init(),
                            d.render(),
                            d.update()),
                        v &&
                            (!e.isElement || (n && "string" != typeof n) || ((n = document.createElement("div")).classList.add("swiper-scrollbar"), e.el.shadowEl.appendChild(n)),
                            n && (c.scrollbar.el = n),
                            u.init(),
                            u.updateSize(),
                            u.setTranslate()),
                        w &&
                            (e.isElement &&
                                ((r && "string" != typeof r) || ((r = document.createElement("div")).classList.add("swiper-button-next"), e.el.shadowEl.appendChild(r)),
                                (a && "string" != typeof a) || ((a = document.createElement("div")).classList.add("swiper-button-prev"), e.el.shadowEl.appendChild(a))),
                            r && (c.navigation.nextEl = r),
                            a && (c.navigation.prevEl = a),
                            p.init(),
                            p.update()),
                        i.includes("allowSlideNext") && (e.allowSlideNext = s.allowSlideNext),
                        i.includes("allowSlidePrev") && (e.allowSlidePrev = s.allowSlidePrev),
                        i.includes("direction") && e.changeDirection(s.direction, !1),
                        (y || A) && e.loopDestroy(),
                        (S || A) && e.loopCreate(),
                        e.update();
                })({
                    swiper: this.swiper,
                    passedParams: this.passedParams,
                    changedParams: [me(e)],
                    ...("navigation" === e && i[e] ? { prevEl: ".swiper-button-prev", nextEl: ".swiper-button-next" } : {}),
                    ...("pagination" === e && i[e] ? { paginationEl: ".swiper-pagination" } : {}),
                    ...("scrollbar" === e && i[e] ? { scrollbarEl: ".swiper-scrollbar" } : {}),
                });
        }
        attributeChangedCallback(e, t, s) {
            this.initialized && ("true" === t && null === s && (s = !1), this.updateSwiperOnPropChange(e, s));
        }
        static get observedAttributes() {
            return pe
                .filter((e) => e.includes("_"))
                .map((e) =>
                    e
                        .replace(/[A-Z]/g, (e) => `-${e}`)
                        .replace("_", "")
                        .toLowerCase()
                );
        }
    }
    pe.forEach((e) => {
        "init" !== e &&
            ((e = e.replace("_", "")),
            Object.defineProperty(SwiperContainer.prototype, e, {
                configurable: !0,
                get() {
                    return (this.passedParams || {})[e];
                },
                set(t) {
                    this.passedParams || (this.passedParams = {}), (this.passedParams[e] = t), this.initialized && this.updateSwiperOnPropChange(e);
                },
            }));
    });
    class SwiperSlide extends Se {
        constructor() {
            super(), (this.tempDiv = document.createElement("div")), (this.shadowEl = this.attachShadow({ mode: "open" }));
        }
        render() {
            const e = this.lazy || "" === this.getAttribute("lazy") || "true" === this.getAttribute("lazy");
            if (
                ((this.tempDiv.innerHTML = "<slot />"),
                [...this.tempDiv.children].forEach((e) => {
                    this.shadowEl.appendChild(e);
                }),
                e)
            ) {
                const e = document.createElement("div");
                e.classList.add("swiper-lazy-preloader"), this.appendChild(e);
            }
        }
        initialize() {
            this.render();
        }
        connectedCallback() {
            this.initialize();
        }
    }
    "undefined" != typeof window &&
        (window.SwiperElementRegisterParams = (e) => {
            pe.push(...e);
        }),
        ((e = !0) => {
            "undefined" != typeof window &&
                (e || (we = !1),
                we && ye(!0),
                window.customElements.get("swiper-container") || window.customElements.define("swiper-container", SwiperContainer),
                window.customElements.get("swiper-slide") || window.customElements.define("swiper-slide", SwiperSlide));
        })(),
        r()
            .then(() => {
                const e = document.querySelector(".js-wbsk-sidebar-cart__cart-count"),
                    t = document.querySelector(".js-wbsk-sidebar-cart__open"),
                    s = document.querySelector("global-sidebar-cart");
                t.addEventListener("click", () => {
                    s.toggle();
                }),
                    s.subscribe(() => {
                        e.innerText = s.cart_data.item_count;
                    });
                const i = document.querySelector(".js-mobile-nav");
                function r() {
                    const e = document.querySelector(".js-header"),
                        t = e.getBoundingClientRect();
                    window.pageYOffset > t.height ? e.classList.add("mh--is-scrolled") : e.classList.remove("mh--is-scrolled");
                }
                document.querySelector(".js-mobile-nav-toggle").addEventListener("click", () => {
                    i.open();
                }),
                    ["resize", "scroll"].forEach((e) =>
                        window.addEventListener(e, () => {
                            r();
                        })
                    ),
                    r();
            })
            .catch((e) => {
                console.log(e);
            }),
        (function () {
            const e = () => {
                const e = document.querySelector(".js-header"),
                    t = window.innerHeight - e.offsetHeight;
                document.querySelectorAll(".js-sticky-wrapper").forEach((s) => {
                    const i = s.offsetHeight - t;
                    s.style.top = i > 0 ? `${0 - i + e.offsetHeight}px` : `${e.offsetHeight}px`;
                });
            };
            r()
                .then(() => {
                    e(),
                        window.addEventListener("resize", () => {
                            e();
                        });
                })
                .catch((e) => {
                    console.log(e);
                });
        })();
    var Ae = self;
    for (var Ee in t) Ae[Ee] = t[Ee];
    t.__esModule && Object.defineProperty(Ae, "__esModule", { value: !0 });
})();

